import React, { useState, useEffect, useRef, useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import {
    Modal,
    CardContent,
    CardHeader,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Tab,
    Tabs,
    Tooltip,
    IconButton,
    Avatar,
    Box,
    Typography,
    Stack,
    TextField,
    Autocomplete,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";

import Badge from "@mui/material/Badge";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ServiceRequestLogIcon from "@mui/icons-material/Article";
import SubjectIcon from "@mui/icons-material/Subject";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Visibility from '@mui/icons-material/Visibility';

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate, useParams } from "react-router-dom";

import CrudService from "services/cruds-service";
import DataTable from "examples/Tables/DataTable";
import ServiceRequestDataTable from "examples/Tables/ServiceRequestDataTable";
import moment from "moment";
import CollapsibleTable from "examples/Tables/ExpandTable";
import AlertRulesForm from "../alertrule/new";
import ServiceRequestsForm from "../service-request/new";
import ServiceRequestStatusLogForm from "../service-request/log";
import DeviceDisconnectForm from "../disconnect-device";
import MultiSeviceRequestStatusEditForm from "../service-request/multiStatusEdit";
import MDAlert from "components/MDAlert";
import GoogleMapComponent from "examples/Maps";
import { useMediaQuery } from "react-responsive";
import { Can } from "Can";
import breakpoints from "assets/theme/base/breakpoints";
import { useWebSocket } from "context/WebSocketContext";
import Thresholds from "../../thresolds";
import { validateInput } from "utils/constant";
import { toast } from "react-toastify";
import AssetTrackerMap from "examples/Maps/assetTrackerMap";
import JsonTree from "cruds/campaign/modal/jsontree";
import RouteCollapsibleTabTable from "examples/Tables/RouteCollapseTable/RouteCollapsibleTabTable";
import convertUtils from 'convert-units';
import RouteModal from "../RouteModel";
import HistoryIcon from '@mui/icons-material/History';
import { counter_data, show_current_data, show_device_signal_data, show_transmission_data, formatDuration, gpsStatusBadgeColor } from "utils/constant";
import { getDuration } from "utils/utils";
import FormField from "layouts/applications/wizard/components/FormField";
import AssetTrackerMapPrevRouteView from "examples/Maps/assetTrackerMapPrevRouteView";
import ContactDeviceAccess from "../../contact_device_access";
import { serviceRequestStatusColor } from "utils/constant";
import { AuthContext } from "context";
import MDDatePicker from "components/MDDatePicker";
import {
    devStyle,
    StackSkeleton,
    StyledBadge,
    DisplayGeofenceLocation,
    DynamicDataTable,
    RenderTR,
} from './misc';
import {
    cond,
    formatValue,
    formatValueForSignal,
    getKeyWithSpecialValue
} from './utils';
import MDInput from "components/MDInput";
import LogsTable from "../table-view/logsTable";
import EventsTable from "../table-view/eventsTable";
import LinkedDeviceView from "../LinkedDeviceView";

const AssetTracker = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const serviceRequestSelectedTab = localStorage.getItem("serviceRequestTab") ?? 0;

    const [name, setName] = useState({
        text: "",
        error: false,
        textError: "",
    });
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

    const [paramValues, setParamValues] = useState([]);
    const [paramValue, setParamValue] = useState();
    const [device, setDevice] = useState();
    const [tableData, setTableData] = useState([]);
    const [serviceStatusUpdate, setServiceStatusUpdate] = useState("");
    const [serviceRequestId, setServiceRequestId] = useState("");
    const [logServiceRequestId, setLogServiceRequestId] = useState("");
    const [deviceDisconnectModal, setDeviceDisconnectModal] = useState(false);
    const [expandedIndexArray, setExpandedIndexArray] = useState([
        true,
        true,
        true,
        ...Array(6).fill(false),
    ]);
    const [isNotified, setNotified] = useState(false);
    const [isShare, setShare] = useState(false);
    const [selectedTab, setSelectedTab] = useState(
        parseInt(serviceRequestSelectedTab)
    );

    const [openViewModal, setOpenViewModal] = useState(false);
    const [serviceRequestLogModal, setServiceRequestLogModal] = useState(false);
    const [alert, setAlert] = useState();
    const [alertTableData, setAlertTableData] = useState([]);

    const [alertRule, setAlertRule] = useState([]);
    const [eventTableData, setEventTableData] = useState([]);
    const [serviceRequests, setServiceRequests] = useState([]);
    const [serviceRequest, setServiceRequest] = useState([]);
    const [alertRuleTableData, setAlertRuleTableData] = useState([]);
    const [serviceRequestTableData, setServiceRequestTableData] = useState([]);

    /////////// service request ////////////
    const [openServiceModal, setServiceModal] = useState(false);
    const [serviceRequestEditFlag, setServiceRequestEditFlag] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
    const [checkRowSelectedRowsFlag, setCheckSelectedRowsFlag] = useState(false);
    const [selectedRowsIdArray, setSelectedRowsIdArray] = useState([]);
    const [multiStatusEditModal, setMultiStatusEditModal] = useState(false);
    const [dataTableUpdate, setDataTableUpdate] = useState("");
    const [selectedRequestType, setSelectedRequestType] = useState("");
    const [serviceRequestDeleteFlag, setServiceRequestDeleteFlag] =
        useState(false);

    const [notification, setNotification] = useState({
        value: false,
        text: "",
    });

    const [providersState, setProvidersState] = useState([]);
    const [activeAlerts, setActiveAlerts] = useState([]);
    const [loaderT, setLoaderT] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [phoneEnvModal, setPhoneEnvModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [phoneEnv, setPhoneEnv] = useState({
        is_production: false,
        is_sandbox: false,
        is_development: true,
    });
    const [gps, setGps] = useState({ latitude: "", longitude: "", edit: false });
    const [tabsOrientation, setTabsOrientation] = useState("horizontal");
    const [reportType, setReportType] = useState({});
    const [wsEmit, setEmit] = useState(1);

    const [openMonitorEditModal, setOpenMonitorEditModal] = useState(false);
    const [selectedThresholds, setSelectedThresholds] = useState([]);

    ///////////////// contact addresss ////////////////
    const [openContactDetailsEditModal, setOpenContactDetailsEditModal] = useState(false);

    const [openDeviceInfoEditModal, setOpenDeviceInfoEditModal] = useState(false);
    ///////////////// Device Setup ////////////////
    const [openDeviceSetupEditModal, setOpenDeviceSetupEditModal] =
        useState(false);
    const [deviceSetupFields, setDeviceSetupFields] = useState({
        depth: "",
        shape: "",
        width: "",
        length: "",
        latitude: "",
        longitude: "",
    });
    const [originalDeviceSetupFields, setOriginalDeviceSetupFields] = useState({
        depth: "",
        shape: "",
        width: "",
        length: "",
        latitude: "",
        longitude: "",
    });
    const [navbarTitle, setNavbarTitle] = useState("");
    const [selectedLogs, setSelectedLogs] = useState([])
    const [selectedEvent, setSelectedEvent] = useState([])
    const [gpsStatus, setGpsStatus] = useState(null)
    const [gpsData, setGpsData] = useState({ latitude: null, longitude: null, heading: null })
    const [parameters, setParameter] = useState([])
    const [mapIcon, setMapIcon] = useState(null)
    const [titleIcon, setTitleIcon] = useState(null)
    const [updateApi, setUpdateApi] = useState(false)
    const [deviceName, setDeviceName] = useState(null)
    const [openJsonTree, setJsonTree] = useState(false)
    const [rawDataValue, setRawDataValue] = useState({})
    const [loaderTable, setLoaderTable] = useState(false)
    const [reporting, setReporting] = useState(false)
    const [routeData, setRouteData] = useState([]);
    const [icons, setIcons] = useState(null);
    const [routeAllData, setRouteAllData] = useState([]);
    const [templateValuesList, setTemplateValuesList] = useState([]);
    const [highlightRouteData, setHighlightRouteData] = useState([])
    const [geofence, setGeofence] = useState(null)
    const [geofenceIcon, setGeofenceIcon] = useState(null)
    const [selectedRouteGroup, setSelectedRouteGroup] = useState(null)
    const [trackingCounter, setTrackingCounter] = useState(null)
    const [ignoreHeading, setIgnoreHeading] = useState(null)
    const uiPage = useRef(null)
    const [selectedLogInfo, setSelectedLogInfo] = useState(null)
    const [requiredThresholds, setRequiredThresholds] = useState([])
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const countRef = useRef(0);
    const [logPage, setLogPage] = useState(0);
    const [logRowsPerPage, setLogRowsPerPage] = useState(50);
    const logCountRef = useRef(0);
    const [iconList, setIconList] = useState([])
    const [modelist, setModeList] = useState([])
    const [selectedMode, setSelectedMode] = useState(null)
    const [mapIdentifier, setMapIdentifier] = useState(null)
    const [selectedIcon, setSelectedIcon] = useState(null)
    const [activeServiceRequest, setActiveServiceRequest] = useState(null);
    const { assetTrackerData, serviceRequestData, alertData } = useWebSocket();
    const authContext = useContext(AuthContext)
    const selectedContactDeviceAccess = useRef([])
    const [notifyAlert, setNotifyAlert] = useState(null)
    const [deviceLogModel, setDeviceLogModel] = useState(false);
    const [dateRange, setDateRange] = useState([null, null]);
    const [pagin, setpagin] = useState([1, 100]);
    const [linkedDeviceData, setLinkedDeviceData] = useState([])

    useEffect(() => {
        if (assetTrackerData && assetTrackerData.device_id == id) {
            updateDevice(assetTrackerData.data)
        }
    }, [assetTrackerData, id]);

    useEffect(() => {
        if (alertData && alertData.device_id == id) {
            updateAlert(alertData.alert, alertData.type)
        }
    }, [alertData, id]);

    useEffect(() => {
        if (id && serviceRequestData) {
            if (serviceRequestData.device_id == id) {
                checkActiveServiceRequest();
            }
        }
    }, [id, serviceRequestData]);

    useEffect(() => {
        if (!id) return;
        (async () => {
            try {
                setLoader(true)
                const res = await CrudService.getDeviceAssetTrackerView(id);

                setDevice(res?.data);

                let icons = res?.data?.attributes?.EntityAddressItem?.Icon
                setMapIcon(icons?.class_name)
                setIgnoreHeading(res?.data?.attributes?.EntityAddressItem?.ignore_heading)
                setTitleIcon(icons?.class_name)
                setSelectedIcon(icons)
                setDeviceName(res?.data?.attributes?.name)
                const newDeviceThresholds = res.data.deviceThresholds?.map(
                    (threshold) => ({
                        ...threshold,
                        label: threshold?.DeviceParameter?.parameter_name,
                        parameter_name: threshold?.DeviceParameter?.parameter_name,
                        is_threshold_required:
                            threshold?.DeviceParameter?.is_threshold_required,
                        field_type_id: threshold?.DeviceParameter?.field_type_id,
                        MessageTemplate: { attributes: threshold?.MessageTemplate },
                    })
                );
                setSelectedThresholds(newDeviceThresholds);
                setReporting(res?.data?.latestWebhookData ? res?.data?.latestWebhookData?.value?.timestamp : null)

                setProvidersState(
                    res?.data?.entityAddressItemProviders.map((provider) => ({
                        association_id: provider?.association_id,
                        on_off:
                            (provider?.provider_devices?.length
                                ? provider?.provider_devices[0].on_off
                                : provider?.on_off) || false,
                    }))
                );
                if (res?.data?.reportTypes) {
                    let obj = {};
                    for (let report of res?.data?.reportTypes) {
                        obj[report.report_type_identifier] = report.report_type_name;
                    }
                    setReportType(obj);
                }

                setName({ text: res.data.attributes?.name });
                setNotified(res.data.attributes?.is_notified);
                setShare(res.data.attributes?.PublicShareDevice?.is_public ?? false);
                const selected_phone = res.data.attributes?.SelectedPhone;
                setPhoneEnv({
                    is_production: selected_phone?.is_production,
                    is_sandbox: selected_phone?.is_sandbox,
                    is_development: selected_phone?.is_development,
                });
                setSelectedMode(res.data.attributes.DeviceMode)
                setMapIdentifier(res.data.attributes?.EntityAddressItem?.map_identifier ?? '')
                let lastRecord;

                // setParamValues(res?.data?.monitorParameterValues);
                lastRecord = res?.data?.latestWebhookData?.device_value ??  res?.data?.latestWebhookData?.value;
                setParamValue(lastRecord);
                let linked_devices = res?.data?.latestWebhookData?.children?.length > 0 ? res?.data?.latestWebhookData?.children : (res?.data?.latestWebhookData?.parents ?? [])
                setLinkedDeviceData(linked_devices)
                setGpsStatus(lastRecord?.moment_status)
                setLoader(false);
                if (!lastRecord) {
                    setNotifyAlert(`There is no logs data available for this device`)
                    return
                }

                try {

                    const isGeofenceExist = await CrudService.checkGeofenceExist({
                        lat: lastRecord?.position_latitude,
                        lng: lastRecord?.position_longitude,
                        entity_id: res?.data?.attributes?.EntityAddressItem?.entity_id,
                        device_id: Number(id),
                        address_item_id: res?.data?.attributes?.EntityAddressItem?.address_item_id
                    })

                    if (isGeofenceExist?.success) {
                        setGeofenceIcon(isGeofenceExist.icons)
                        setGeofence(isGeofenceExist.data)
                    }
                } catch (error) {
                    console.error('isGeofenceExist', error)
                }


                let heading = (lastRecord?.position_direction + 360) % 360;
                setGpsData(() => ({
                    latitude: lastRecord?.position_latitude ?? 0,
                    longitude: lastRecord?.position_longitude ?? 0,
                    heading: heading ?? 0,
                }))

                const deviceParameter = await CrudService.getDeviceParameter();
                setParameter(() => [...deviceParameter.data])

                const trackingRes = await CrudService.getTrackingCounter(id);
                if (trackingRes.success) {
                    setTrackingCounter(trackingRes.data)
                }

                let route_utils = await CrudService.getRoutesUtils();
                setTemplateValuesList(route_utils.route_template_values)
                setIcons(route_utils?.icons)
                let today_routes = await CrudService.getTodayRoutes(id);
                if (today_routes?.success) {
                    setRouteData(today_routes.data.length > 0 ? [today_routes.data[0]] : today_routes.data);
                }

                const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(id);
                let alertData = deviceAlertsRes?.data?.alerts?.reverse()
                setActiveAlerts(alertData);

                checkActiveServiceRequest();
                if (selectedTab === 4) {
                    serviceRequestList(res?.data?.attributes?.EntityAddressItem?.address_item_id)
                }

                // let deviceThresholds = res?.data?.deviceThresholds;
                // for (let deviceThreshold of deviceThresholds) {
                //     if ([1, 26].includes(deviceThreshold.threshold_type_id)) {
                //         let color = "rgb(38, 40, 51);";
                //         let comparison_operator_id = deviceThreshold.comparison_operator_id;
                //         const parameterName =
                //             deviceThreshold?.DeviceParameter?.parameter_name;

                //         const parameterMapping = {
                //             percent_level: "percent_level",
                //             Temperature: "enclosure_temperature",
                //             product_level: "inch_level",
                //             measured_height: "measured_height",
                //         };

                //         const propertyKey = parameterMapping[parameterName];
                //         const parameterValue = parseInt(
                //             lastRecord?.device_data?.[propertyKey]
                //         );
                //         const thresholdValue = parseInt(deviceThreshold.threshold_value);

                //         if (propertyKey === undefined) {
                //             // console.error(`Unknown parameter name: ${parameterName}`);
                //             return;
                //         }
                //     }
                // }
            } catch (err) {
                if (err.status == 400) {
                    navigate("/user-profile");
                }
                console.error(err);
            }
        })();
        return () => resetState()
    }, [id, dataTableUpdate, serviceStatusUpdate]);

    useEffect(() => {
        if (selectedTab == 0) {
            // monitorLogs(logPage, logRowsPerPage);
        }
        if (selectedTab == 1) {
            allAlerts(page, rowsPerPage)
        }
        if (selectedTab === 2) {
            allRoute(page, rowsPerPage)
        }
        if (selectedTab === 4) {
            alertRulesList()
        }
        if (selectedTab === 5) {
            serviceRequestList()
        }
    }, [id, page, rowsPerPage, selectedTab, logPage, logRowsPerPage])

    useEffect(() => {
        if (paramValues.length) {
            setTableData(getRows(paramValues));
            if (paramValues.length) {
                setLoaderT(false);
            }
        }
    }, [paramValues])

    function resetState() {
        setName({ text: "", error: false, textError: "" });
        setParamValues([]);
        setParamValue(undefined);
        setDevice(null);
        setTableData([]);
        setServiceStatusUpdate("");
        setServiceRequestId("");
        setLogServiceRequestId("");
        setDeviceDisconnectModal(false);
        setExpandedIndexArray([true, true, true, ...Array(6).fill(false)]);
        setNotified(false);
        setShare(false);
        setSelectedTab(parseInt(serviceRequestSelectedTab));
        setOpenViewModal(false);
        setServiceRequestLogModal(false);
        setAlert(undefined);
        setAlertTableData([]);
        setAlertRule([]);
        setEventTableData([]);
        setServiceRequests([]);
        setServiceRequest([]);
        setAlertRuleTableData([]);
        setServiceRequestTableData([]);
        setServiceModal(false);
        setServiceRequestEditFlag(false);
        setSelectedRows({});
        setCheckSelectedRowsFlag(false);
        setSelectedRowsIdArray([]);
        setMultiStatusEditModal(false);
        setDataTableUpdate("");
        setSelectedRequestType("");
        setServiceRequestDeleteFlag(false);
        setNotification({ value: false, text: "" });
        setProvidersState([]);
        setActiveAlerts([]);
        setLoaderT(true);
        setOpenModal(false);
        setPhoneEnvModal(false);
        setLoader(false);
        setPhoneEnv({ is_production: false, is_sandbox: false, is_development: true });
        setGps({ latitude: "", longitude: "", edit: false });
        setTabsOrientation("horizontal");
        setReportType({});
        setEmit(1);
        setOpenMonitorEditModal(false);
        setSelectedThresholds([]);
        setOpenContactDetailsEditModal(false);
        setOpenDeviceInfoEditModal(false);
        setOpenDeviceSetupEditModal(false);
        setDeviceSetupFields({ depth: "", shape: "", width: "", length: "", latitude: "", longitude: "" });
        setOriginalDeviceSetupFields({ depth: "", shape: "", width: "", length: "", latitude: "", longitude: "" });
        setNavbarTitle("");
        setSelectedLogs([]);
        setSelectedEvent([]);
        setGpsStatus(null);
        setGpsData({ latitude: null, longitude: null, heading: null });
        setParameter([]);
        setMapIcon(null);
        setTitleIcon(null);
        setUpdateApi(false);
        setDeviceName(null);
        setJsonTree(false);
        setRawDataValue({});
        setLoaderTable(false);
        setReporting(false);
        setRouteData([]);
        setIcons(null);
        setRouteAllData([]);
        setTemplateValuesList([]);
        setHighlightRouteData([]);
        setGeofence(null);
        setGeofenceIcon(null);
        setSelectedRouteGroup(null);
        setTrackingCounter(null);
        setIgnoreHeading(null);
        setSelectedLogInfo(null);
        setRequiredThresholds([]);
        setPage(0);
        setRowsPerPage(10);
        setIconList([]);
        setModeList([]);
        setSelectedMode(null);
        setMapIdentifier(null);
        setSelectedIcon(null);
        setActiveServiceRequest(null);
        setNotifyAlert(null);
    }

    async function updateDevice(data, geofence) {
        let latestRecord = data;
        setParamValue(latestRecord);
        setGpsStatus(latestRecord?.moment_status)
        let heading = (latestRecord?.position_direction + 360) % 360;
        setGpsData(() => ({
            latitude: latestRecord?.position_latitude ?? 0,
            longitude: latestRecord?.position_longitude ?? 0,
            heading: heading ?? 0,
        }))
        if (geofence) {
            setGeofence(geofence)
        }
        if (data?.linked_devices) {
            setLinkedDeviceData(data?.linked_devices)
        }
        // if (selectedTab == 0 && Object.keys(reportType).length > 0) {
        //     monitorLogs();
        // }
    }

    async function updateAlert(data, type) {
        if (type == 'Heal') {
            const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(id);
            let alertData = deviceAlertsRes?.data?.alerts?.reverse()
            setActiveAlerts(alertData ?? []);
        } else {
            setActiveAlerts((prev) => [...prev, data]);
        }
    }

    async function checkActiveServiceRequest() {
        try {
            const serviceAlertsRes = await CrudService.getActiveServiceRequest(id);
            setActiveServiceRequest(serviceAlertsRes?.data);
        } catch (err) {
            console.error('checkActiveServiceRequest', err)
        }
    }

    async function monitorLogs(page, pageSize) {
        try {

            // let resp = await CrudService.getDeviceMonitorLogs({id, page: page + 1, pageSize})
            let resp = await CrudService.getDeviceMonitorLogs(id, 1, 100)

            if (resp.success) {
                setParamValues(resp.data)
                // logCountRef.current = resp.pagination.total
            }

        } catch (error) {
            console.error('monitorLogs', error)
        }
    }

    async function allAlerts(page, rowsPerPage) {
        try {
            let resp = await CrudService.getDeviceAlerts(id, page, rowsPerPage);
            let alertFilter = getAlertRows(resp.data);
            setAlertTableData(alertFilter);
            countRef.current = resp?.pagination?.total ?? resp?.count
        } catch (error) {
            console.error('allAlerts', error)
        }
    }

    async function allRoute(page, rowsPerPage) {
        try {

            let all_routes = await CrudService.getRoutes(id, page, rowsPerPage);
            if (all_routes.success) {
                setRouteAllData(all_routes.data);
                countRef.current = all_routes.count
            }

        } catch (error) {
            console.error('AllRoute error', error)
        }
    }

    async function allEvents() {
        try {
            let resp = await CrudService.getDeviceEvent(id);
            if (resp?.data) {
                let eventList = resp.data.reverse()
                const eventRows = getEventRows(eventList)
                setEventTableData(eventRows);
            }
        } catch (error) {
            console.error('allEvents', error)
        }
    }

    async function alertRulesList() {
        try {
            const resp = await CrudService.getAlertRules({ id });
            if (resp.data) {
                let rules = getAlertRuleRows(resp.data)
                setAlertRuleTableData(rules);
            }
        } catch (error) {
            console.error('alertRules', error)
        }
    }

    function updateNewRules(data) {
        let rules = getAlertRuleRows(data)
        setAlertRuleTableData(rules);
    }

    async function serviceRequestList(address_id = null) {
        let address_item_id = address_id ?? device?.attributes?.EntityAddressItem?.address_item_id;

        if (address_item_id) {
            const resp = await CrudService.getServiceRequests(address_item_id);
            if (resp.data) {
                setServiceRequests(resp.data);
                let requests = getServiceRequestRows(resp.data)
                setServiceRequestTableData(requests);
            }
        }
    }

    useEffect(() => {
        (async () => {

            if (!updateApi) {
                return
            }
            let today_routes = await CrudService.getTodayRoutes(id);
            if (today_routes?.success) {
                setRouteData(today_routes.data.length > 0 ? [today_routes.data[0]] : today_routes.data);
            }
            const res = await CrudService.getDeviceAssetTrackerView(id, true);

            let lastRecord = res?.data?.latestWebhookData;

            setReporting(lastRecord ? lastRecord?.timestamp : null)
            setParamValue(lastRecord);
            if (lastRecord?.linked_devices) {
                setLinkedDeviceData(lastRecord?.linked_devices)
            }

            const trackingRes = await CrudService.getTrackingCounter(id);
            if (trackingRes.success) {
                setTrackingCounter(trackingRes.data)
            }

            let heading = (lastRecord?.position_direction + 360) % 360;
            setGpsData(() => ({
                latitude: lastRecord.position_latitude ?? 0,
                longitude: lastRecord?.position_longitude ?? 0,
                heading: heading ?? 0,
            }))
            setGpsStatus(lastRecord?.moment_status)
            if (assetTrackerData.geofence) {
                setGeofence(assetTrackerData.geofence)
            } else {
                setGeofence(null)
            }
            const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(id);
            setActiveAlerts(deviceAlertsRes?.data?.alerts);
            if (selectedTab == 2) {
                allRoute(page, rowsPerPage)
            }
            if (selectedTab == 0) {
                let payload = {
                    created_at: new Date(),
                    data: assetTrackerData.data,
                    id: '-',
                    status_name: 'Working'
                }
                setParamValues((e) => [payload, ...e])
            }
            setLoader(false);
        })()
    }, [wsEmit])

    useEffect(() => {
        checkRowSelected();
    }, [selectedRows]);

    useEffect(() => {
        if (notification.value === true) {
            let timer = setTimeout(() => {
                setNotification({
                    value: false,
                    text: "",
                });
            }, 5000);
        }
    }, [notification]);

    useEffect(() => {
        function handleScroll() {
            if (window.scrollY > 100) {
                setNavbarTitle(device?.attributes?.name || ""); // Set device name when scrolled down
            } else {
                setNavbarTitle(""); // Remove when scrolled up
            }
        }

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [device?.attributes?.name]);

    useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
            return window.innerWidth < breakpoints.values.sm
                ? setTabsOrientation("vertical")
                : setTabsOrientation("horizontal");
        }

        /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
        window.addEventListener("resize", handleTabsOrientation);

        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [tabsOrientation]);

    function canContinueCurrentData(paramValue, parameter) {
        let checkParam = ['average_fuel_consumption', 'can_engine_coolant_temperature', 'can_intake_air_temperature']
        if (!checkParam.includes(parameter)) {
            return true
        }
        if (paramValue[parameter] != 0) {
            return true
        }
        return false
    }

    const handlePhoneSwitch = (value, attr) => {
        setPhoneEnv((e) => ({ ...e, [attr]: value }));
    };

    function checkAccess() {
        if (authContext.userDetail.role_id === 1) {
            return true
        }
        if (authContext.accessList.writeAccess.includes(Number(id))) {
            return true
        }

        return false
    }

    const clickExportLogsHandler = async () => {
        try {
            setDeviceLogModel(true)
        } catch (error) {
            console.error('clickExportLogsHandler error', error)
        }
    }

    const handleExport = async () => {
        try {
            const from_date = moment(dateRange[0][0]).format('YYYY-MM-DD');
            const to_date = moment(dateRange[1][0]).format('YYYY-MM-DD');

            if (pagin[0] < 1) {
                setNotification({
                    value: true,
                    text: 'Page should positive number',
                })
                return
            }

            if (pagin[1] < 1) {
                setNotification({
                    value: true,
                    text: 'No. of Pages should positive number',
                })
                return
            }

            const exportUrl = `${process.env.REACT_APP_API_URL}/devices/export/excel?device_id=${id}&from_date=${from_date}&to_date=${to_date}&page=${pagin[0]}&limit=${pagin[1]}`;
            window.open(exportUrl, '_blank');
            setDateRange([null, null])
            setDeviceLogModel(false)
        } catch (error) {
            console.error('clickExportLogsHandler error', error)
        }
    }

    const deviceSignalSubHeaderStyle = {
        color: '#fff',
        margin: '5px 0'
    }

    const clickSetPhoneOption = async () => {
        const res = await CrudService.setPhoneOption({
            device_id: device.id,
            option: phoneEnv,
        });
        if (res.success) {
            device.attributes.SelectedPhone = {
                ...device.attributes.SelectedPhone,
                ...phoneEnv,
            };
        }

        setNotification({
            value: true,
            text: res.msg,
            bgColor: "info",
        });
        setPhoneEnvModal(false);
    };

    const clickCancelSelection = (e) => {
        setSelectedRows([]);
    };
    const checkRowSelected = () => {
        let result = false;
        let _selectedRowIdArray = [];

        for (const key in selectedRows) {
            if (selectedRows?.[key] == true) {
                result = true;
                _selectedRowIdArray.push(key);
            }
        }
        setSelectedRowsIdArray(_selectedRowIdArray);
        setCheckSelectedRowsFlag(result);
    };

    const showToast = (result) => {
        setNotification({
            value: true,
            text: result.message,
            bgColor: result.status == "201" ? "info" : "error",
        });
    };

    const handleCloseMultiStatusEditModal = () => {
        setMultiStatusEditModal(false);
    };

    const handleOpenMonitorEditModal = () => {
        const newDeviceThresholds = device.deviceThresholds?.map((threshold) => ({
            ...threshold,
            label: threshold?.DeviceParameter?.parameter_name,
            parameter_name: threshold?.DeviceParameter?.parameter_name,
            is_threshold_required: threshold?.DeviceParameter?.is_threshold_required,
            field_type_id: threshold?.DeviceParameter?.field_type_id,
            MessageTemplate: { attributes: threshold?.MessageTemplate },
        }));
        setSelectedThresholds(newDeviceThresholds);
        setOpenMonitorEditModal(true);
    };

    const handleCloseMonitorEditModal = () => {
        setOpenMonitorEditModal(false);
    };

    const handleOpenContactsDetailsEditModal = () => {
        setOpenContactDetailsEditModal(true);
    };

    const handleCloseContactDetailsEditModal = () => {
        setOpenContactDetailsEditModal(false);
    };

    const handleOpenDeviceSetupEditModal = () => {
        setOriginalDeviceSetupFields(deviceSetupFields);
        setOpenDeviceSetupEditModal(true);
    };

    const handleCloseDeviceSetupEditModal = () => {
        setDeviceSetupFields(originalDeviceSetupFields);
        setOpenDeviceSetupEditModal(false);
    };

    const handleOpenDeviceInfoEditModal = async () => {
        const resIconsList = await CrudService.getIcons();
        if (resIconsList) {
            let filterIconList = resIconsList.data.filter((e) => e.class_name !== null)
            setIconList(filterIconList)
        }
        const resModeList = await CrudService.getDeviceModes();
        if (resModeList) {
            setModeList(resModeList.data)
        }
        setOriginalDeviceSetupFields(deviceSetupFields);
        setOpenDeviceInfoEditModal(true);
    };

    const handleCloseDeviceInfoEditModal = () => {
        setDeviceSetupFields(originalDeviceSetupFields);
        setOpenDeviceInfoEditModal(false);
    };

    const handleLocationChange = (newLocation) => {
        const payload = {
            deviceId: device.id,
            addressItemId: device?.attributes?.EntityAddressItem?.address_item_id,
            attributes: {
                ...deviceSetupFields,
                latitude: newLocation.lat,
                longitude: newLocation.lng,
            },
        };

        setDeviceSetupFields({
            ...deviceSetupFields,
            latitude: newLocation.lat,
            longitude: newLocation.lng,
        });

        handleSubmitDeviceInfoEdit(payload);
    };


    const handleSubmitContactDetailsEdit = async (e) => {
        e.preventDefault();

        let payload = {
            address_item_id: device?.attributes?.EntityAddressItem?.address_item_id,
            payload: selectedContactDeviceAccess.current
        }

        try {

            let resp = await CrudService.updateContactDeviceAccess(payload)

            if (resp.success) {
                toast.success(resp.msg)
                setDevice((prevDevice) => ({
                    ...prevDevice,
                    contacts: resp.data,
                }));
                setOpenContactDetailsEditModal(false)
            } else {
                toast.info(resp.msg ?? 'Issue occured')
            }

        } catch (error) {
            console.error('handleSubmitContactDetailsEdit', error)
            toast.error(error.error)
        }
    };

    const handleSubmitMonitorEdit = async (e) => {
        e.preventDefault();
        let hasValidationError = false;
        const updatedSelectedThresholds = [...selectedThresholds];
        let list_of_required;
        let thresholdMapped = updatedSelectedThresholds.map((e) => e.id)
        let hasRequiredError = requiredThresholds.every((e) => {
            if (thresholdMapped.includes(e.id)) {
                return true
            }
            list_of_required = e
            return false
        })
        if (!hasRequiredError) {
            toast.info(`Parameter ${list_of_required.DeviceParameter.parameter_name} is required!`)
            return
        }
        updatedSelectedThresholds.forEach((updatedSelectedThreshold) => {
            const validError = validateInput(
                updatedSelectedThreshold?.field_type_id,
                updatedSelectedThreshold?.threshold_value
            );
            updatedSelectedThreshold.validationError = validError;
            if (validError) {
                hasValidationError = validError;
                return;
            }
        });


        if (hasValidationError) {
            toast.info(`Validation error!`)
            return
        };

        // if (updatedSelectedThresholds.some(item => [null, undefined].includes(item.group_id))) {
        //     setNotification({
        //         value: true,
        //         text: "Group ID is required",
        //         bgColor: "error",
        //     });
        //     return;
        // }

        try {
            const payload = {
                deviceId: device.id,
                deviceParameterThresholds: updatedSelectedThresholds,
            };
            const response = await CrudService.updateDeviceThreshold(payload);
            setDevice((prev) => ({
                ...prev,
                deviceThresholds: response.data,
            }));
            setSelectedThresholds(updatedSelectedThresholds);
            setOpenMonitorEditModal(false);
        } catch (err) {
            console.error(err);
            toast.error(err.message)
        }
    };

    const handleSubmitDeviceInformationEdit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                device_id: device.id,
                address_item_id: device.attributes.address_item_id,
                device_name: deviceName,
                latitude: deviceSetupFields.latitude,
                longitude: deviceSetupFields.longitude,
                map_identifier: mapIdentifier,
                mode: selectedMode,
                icon: selectedIcon
            }

            let resp = await CrudService.updateDeviceInformation(payload)

            if (resp.success) {
                toast.info('Updated!')
            } else {
                toast.error(resp.msg)
            }

            setOpenDeviceInfoEditModal(false)
        } catch (err) {
            console.error('handleSubmitDeviceInformationEdit', err)
            toast.error(err.error)
        }
    }

    const handleSubmitDeviceSetupEdit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                deviceId: device.id,
                addressItemId: device?.attributes?.EntityAddressItem?.address_item_id,
                attributes: { ...deviceSetupFields, deviceName },
            };
            await CrudService.updateDeviceAttributes(payload);
            setOpenDeviceSetupEditModal(false);
            setOpenDeviceInfoEditModal(false);
            setName({ text: deviceName })
            setNavbarTitle(deviceName)
            setDevice((prev) => ({ ...prev, attributes: { ...prev.attributes, name: deviceName } }))
        } catch (err) {
            console.error(err);
        }
    };

    const handleSubmitDeviceInfoEdit = async (payload) => {
        try {
            await CrudService.updateDeviceAttributes(payload);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        }
    };

    const getRows = (info) => {
        // Sort info array by id in descending order
        info.sort((a, b) => b.id - a.id);

        let updatedInfo = info.map((row, index) => {
            return {
                ...row,
                id: row?.id,
                report_type: row?.data?.report_reason
                    ? reportType[row?.data?.report_reason] ?? ""
                    : "",
                latitude: row.data?.position_latitude ?? '',
                longitude: row.data?.position_longitude ?? '',
                speed: row.data?.convert_position_speed + ' mph' ?? '',
                direction: row.data?.position_direction ?? '',
                satellite_count: row.data?.position_satellites ?? '',
                external_power_status: row.data?.external_powersource_status ? 'True' : 'False',
                engine_ignition_status: row.data?.engine_ignition_status ? 'True' : 'False',
                date: row?.created_at,
                row_data: row?.data
            };
        });
        return updatedInfo;
    };

    const dataTableData = {
        columns: [
            { Header: "ID", accessor: "id", show: true },
            { Header: "Report Type", accessor: "report_type", show: true },
            {
                Header: "Latitude",
                accessor: "latitude",
            },
            {
                Header: "Longitude",
                accessor: "longitude",
            },
            {
                Header: "Speed",
                accessor: "speed",
            },
            {
                Header: "Direction",
                accessor: "direction",
            },
            {
                Header: "Satellite Count",
                accessor: "satellite_count",
            },
            {
                Header: "External Power Status",
                accessor: "external_power_status",
            },
            {
                Header: "Engine Ignition Status",
                accessor: "engine_ignition_status",
            },
            {
                Header: "Date",
                accessor: "date",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {moment(info.value).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
            {
                Header: "Action",
                accessor: "row_data",
                show: true,
                isSorted: false,
                Cell: (info, data) => {
                    return (
                        <div
                            style={{
                                padding: '5px'
                            }}
                        >
                            <IconButton onClick={(e) => clickLogInfoHandler(e, info.value)}>
                                <Visibility />
                            </IconButton>
                        </div>
                    );
                },
            },
        ],
        rows: tableData, // Assuming tableData is your original data array
    };

    const clickAlertRuleEditHandler = async (ruleId) => {
        let res = await CrudService.getAlertRule(ruleId);
        setAlertRule(res);
        setOpenViewModal(true);
    };

    const clickAlertRuleDeleteHandler = async (e, ruleId) => {
        try {
            if (!confirm("Are you sure you want to delete this alert rule?")) {
                e.nativeEvent.stopImmediatePropagation();
            } else {
                await CrudService.deleteAlertRule(ruleId);
                // the delete does not send a response
                // so I need to get again the categories to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
                alertRulesList();
                setNotification({
                    value: true,
                    text: "The alert rule has been successfully deleted",
                });
            }
        } catch (err) {
            // it sends error is the item is associated with an item
            console.error(err);
            if (err.hasOwnProperty("errors")) {
                setNotification({
                    value: true,
                    text: err.errors[0].detail,
                });
            }
            return null;
        }
    };

    const clickServiceRequestEditHandler = async (e, service_request_id) => {
        e.stopPropagation();
        setServiceRequestEditFlag(true);
        let res = await CrudService.getServiceRequest(service_request_id);

        setServiceRequest(res.data.attributes);
        setServiceModal(true);
    };

    const clickServiceRequestLogHandler = async (e, service_request_id) => {
        e.stopPropagation();
        setServiceRequestLogModal(true);
        setLogServiceRequestId(service_request_id);
        // let res = await CrudService.getServiceRequest(service_request_id);

        // setServiceRequest(res.data.attributes);
    };

    const clickServiceRequestViewHandler = (e, service_request_id) => {
        e.stopPropagation();
        navigate(`/service-request-detail/${service_request_id}`);
    };
    const clickServiceRequestDeleteHandler = async (e, service_request_id) => {
        e.stopPropagation();
        setServiceRequestDeleteFlag(true);
        try {
            if (!confirm("Are you sure you want to delete this service request?")) {
                e.nativeEvent.stopImmediatePropagation();
            } else {
                await CrudService.deleteServiceRequest(service_request_id);
                // the delete does not send a response
                // so I need to get again the categories to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
                const response = await CrudService.getServiceRequests(
                    device?.attributes?.EntityAddressItem.address_item_id
                );
                setServiceRequests(response.data);
                setNotification({
                    value: true,
                    text: "The service request has been successfully deleted",
                });
            }
        } catch (err) {
            // it sends error is the item is associated with an item
            console.error(err);
            if (err.hasOwnProperty("errors")) {
                setNotification({
                    value: true,
                    text: err.errors[0].detail,
                });
            }
            return null;
        }
    };

    const getAlertRuleRows = (info) => {
        let updatedInfo = info.map((row) => {
            let frequency = "";
            if (row.attributes?.frequency && row.attributes?.frequency != null) {
                frequency =
                    row.attributes?.frequency +
                    " min" +
                    (row.attributes?.frequency > 1 ? "(s)" : "");
            }

            let rule_type =
                row.attributes?.module_id === 12
                    ? "Alert"
                    : row.attributes?.module_id === 13
                        ? "Service Request"
                        : "";

            const event_type_id = row.attributes?.event_type_id;
            let message_template_name = "";
            if (event_type_id == 14) {
                message_template_name = row.attributes?.SendgridTemplate?.name;
            }
            if (event_type_id == 15) {
                message_template_name = row.attributes?.MessageTemplate?.name;
            }
            if (event_type_id == 36) {
                message_template_name = row.attributes?.MessageTemplate?.name;
            }
            let { Contact, ContactAddress } = row.attributes
            let address = `${Contact?.first_name} ${Contact?.last_name} - ${ContactAddress?.contact_address}`
            return {
                id: row?.id,
                rule_type: rule_type,
                alert_type: row.attributes?.AlertType?.type_name,
                alert_type_category: row.attributes?.AlertType?.category,
                alert_sub_type: row.attributes?.AlertSubType?.sub_type_name,
                event_type: row.attributes?.EventType?.name,
                message_template_name: message_template_name,
                address: address,
                send_to_type: row.attributes?.SendToType?.send_to_type_name,
                frequency: frequency,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
                status: (
                    <Badge
                        color={
                            row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
                        }
                        variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                        badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
                        style={{ marginLeft: "30px" }}
                    ></Badge>
                ),
            };
        });

        return updatedInfo;
    };

    const alertRuledataTableData = {
        columns: [
            { Header: "ID", accessor: "id", show: true },
            { Header: "Status Badge", accessor: "status", show: true },
            { Header: "Status ", accessor: "status_text", show: false },

            { Header: "Rule Type", accessor: "rule_type", show: true },
            { Header: "Alert Type", accessor: "alert_type", show: true },
            {
                Header: "Alert Type Category",
                accessor: "alert_type_category",
                show: true,
            },
            { Header: "Alert Sub Type", accessor: "alert_sub_type", show: true },
            { Header: "Event Type", accessor: "event_type", show: true },
            {
                Header: "Message Template Name",
                accessor: "message_template_name",
                show: true,
            },
            { Header: "Address", accessor: "address", show: true },
            { Header: "Send Type", accessor: "send_to_type", show: true },
            { Header: "Frequency", accessor: "frequency", show: true },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                show: true,
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            <Tooltip title="Edit Alert Rule">
                                <IconButton
                                    onClick={() =>
                                        clickAlertRuleEditHandler(info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <EditIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Alert Rule">
                                <IconButton
                                    onClick={(e) =>
                                        clickAlertRuleDeleteHandler(e, info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <DeleteIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    );
                },
            },
        ],
        rows: alertRuleTableData, // Assuming tableData is your original data array
    };

    const getEventRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row?.event_id,
                alert_type: row?.AlertType?.type_name,
                parameter_name: row?.DeviceParameter?.parameter_name,
                icon: row?.AlertType?.Icon ? row?.AlertType?.Icon?.class_name : '',
                percent_value: row?.percent_change,
                prev_value: row?.previous_value,
                current_value: row?.new_value,
                volume: row?.volume_change,
                date: row?.event_timestamp,
                raw_data: row?.WebhookRawDatum ? row?.WebhookRawDatum?.value : {}
            };
        });

        return updatedInfo;
    };

    const openJsonTreedata = (e, value) => {
        e.stopPropagation();
        setRawDataValue(value)
        setJsonTree(true)
    }

    const eventdataTableData = {
        columns: [
            {
                Header: "ID",
                accessor: "id",
                show: true,
                Cell: (info) => {
                    return <a onClick={(e) => openJsonTreedata(e, info.cell.row.original.raw_data)}>{info.value}</a>
                }
            },
            {
                Header: "Type",
                accessor: "alert_type",
                show: true,
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center" style={{ color: '#ffffffcc', gap: '0.4rem' }}>
                            <i className={info.cell.row.original.icon} style={{ fontSize: "16px" }}></i> <h6 style={{ fontSize: '0.875rem', margin: 0 }}>{info.value}</h6>
                        </MDBox>
                    )
                }
            },
            {
                Header: "Parameter Name",
                accessor: "parameter_name",
                show: true,
            },
            { Header: "Current Value", accessor: "current_value", show: true },
            { Header: "Previous Value", accessor: "prev_value", show: true },
            // {
            //     Header: "Percent Change",
            //     accessor: "percent_value",
            //     show: true,
            //     Cell: (info) => `${Number(info.value).toFixed(0)}%`,
            // },
            // {
            //     Header: "Volume Change ( Gallons )",
            //     accessor: "volume",
            //     show: true,
            //     Cell: (info) => `${Number(info.value).toFixed(0)}`,
            // },
            {
                Header: "Date",
                accessor: "date",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {moment(info.cell.row.original.date).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
        ],
        rows: eventTableData, // Assuming tableData is your original data array
    };

    const getServiceRequestRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row.attributes?.service_request_id,
                user: row.attributes?.user?.name,
                entityAddressItem: row.attributes?.EntityAddressItem?.name,
                provider: row.attributes?.Provider?.provider_name,
                serviceItem: row.attributes?.ServiceItem?.item_name,
                request_date: row.attributes?.request_date,
                status: row.attributes?.StatusOption,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
            };
        });

        return updatedInfo;
    };

    const serviceRequestdataTableData = {
        columns: [
            { Header: "ID", accessor: "id", width: "12rem", show: true },
            {
                Header: "Status Badge",
                accessor: "",
                width: "12rem",
                show: true,
                Cell: (info) => {
                    return (
                        <StyledBadge
                            color={
                                info.cell.row.original?.status?.BadgeDetail?.color || "primary"
                            }
                            variant={
                                info.cell.row.original?.status?.BadgeDetail?.variant ||
                                "contained"
                            }
                            badgeContent={
                                info.cell.row.original.status?.StatusType?.status_name
                            }
                            style={{ marginLeft: "30px" }}
                        ></StyledBadge>
                    );
                },
            },
            { Header: "Status", accessor: "status_text", width: "12rem", show: true },

            {
                Header: "Entity Address Item",
                accessor: "entityAddressItem",
                width: "12rem",
                show: true,
            },
            { Header: "Provider", accessor: "provider", width: "12rem", show: true },
            {
                Header: "Service Item",
                accessor: "serviceItem",
                width: "12rem",
                show: true,
            },
            {
                Header: "Requested Date",
                accessor: "request_date",
                width: "12rem",
                show: true,
            },
            { Header: "User", accessor: "user", width: "12rem", show: true },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                width: "12rem",
                show: true,
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            <Tooltip title="View Service Request">
                                <IconButton
                                    onClick={(e) =>
                                        clickServiceRequestViewHandler(e, info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <SubjectIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Show Status Change Log">
                                <IconButton
                                    onClick={(e) =>
                                        clickServiceRequestLogHandler(e, info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <ServiceRequestLogIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit Service Request">
                                <IconButton
                                    onClick={(e) =>
                                        clickServiceRequestEditHandler(e, info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <EditIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Service Request">
                                <IconButton
                                    onClick={(e) =>
                                        clickServiceRequestDeleteHandler(
                                            e,
                                            info.cell.row.original.id
                                        )
                                    }
                                >
                                    <MDTypography>
                                        <DeleteIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    );
                },
            },
        ],
        rows: serviceRequestTableData, // Assuming tableData is your original data array
    };

    const getAlertRows = (info) => {
        let updatedInfo = info.map((row) => {
            const createdAt = row.attributes.created_at
                ? moment(row.attributes.created_at).format("MMMM DD, YYYY h:mm:ss A")
                : "";
            const updatedAt = row.attributes.updated_at
                ? moment(row.attributes.updated_at).format("MMMM DD, YYYY h:mm:ss A")
                : "";
            const subType = row.attributes.is_parent
                ? "Alert Created"
                : row.attributes.is_healed
                    ? "Alert Healed"
                    : "Alert Resent";

            return {
                id: row.id,
                device_id: row.attributes?.device_id,
                alert_type_id: row.attributes?.alert_type_id,
                alert_type: row.attributes?.AlertType?.type_name,
                alert_type_category: row.attributes?.AlertType?.category,
                device: row.attributes.Device?.name,
                parameter_name: row.attributes?.DeviceParameter?.label ?? '',
                sub_type: subType,
                is_parent: row.attributes?.is_parent,
                threshold_value: row.attributes.threshold,
                exceed_value: row.attributes.exceed_value,
                current_value: row.current_value,
                created_at: createdAt,
                updated_at: updatedAt,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
                status: (
                    <Badge
                        color={
                            row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
                        }
                        variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                        badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
                        style={{ marginLeft: "30px" }}
                    ></Badge>
                ),
            };
        });
        return updatedInfo;
    };

    const clickStatusEdit = (e) => {
        setMultiStatusEditModal(true);
    };

    const alertColumns = [
        { Header: "ID", accessor: "id", width: "5%", show: true },
        { Header: "Status Badge", accessor: "status", width: "5%", show: true },
        { Header: "Status", accessor: "status_text", show: false },
        { Header: "Alert Type", accessor: "alert_type", width: "10%", show: true },
        { Header: 'Parameter', accessor: 'parameter_name', width: '10%', show: true },
        { Header: 'Threshold Value', accessor: 'threshold_value', width: '5%' },
        { Header: 'Exceed Value', accessor: 'exceed_value', width: '5%' },
        { Header: 'Current Value', accessor: 'current_value', width: '5%' },
        {
            Header: "Alert Category",
            accessor: "alert_type_category",
            width: "10%",
            show: true,
        },
        { Header: "Sub Type", accessor: "sub_type", width: "8%", show: true },
        { Header: "Created At", accessor: "created_at", width: "15%", show: true },
        { Header: "Updated At", accessor: "updated_at", width: "15%", show: true },
        {
            Header: "actions",
            disableSortBy: true,
            accessor: "actions",
            show: true,
        },
    ];
    const routeColumns = [
        { Header: "ID", accessor: "route_id", show: true, width: '3%' },
        {
            Header: "Status", accessor: "status", show: true, width: '5%', Cell: (info, row) => {
                const badgeDetail = row.status_option.BadgeDetail
                return (
                    <Badge
                        color={badgeDetail.color}
                        variant={badgeDetail.variant}
                        badgeContent={info}
                        style={{ marginLeft: "20px" }}
                    ></Badge>
                )
            }
        },
        { Header: "Start Route", accessor: "start_time", show: true, width: '10%' },
        { Header: "End Route", accessor: "end_time", show: true, width: '10%' },
        { Header: "Visited Geofences", accessor: "visited_geofences", show: true, width: '15%' },
        { Header: "Total Time(Geofences)", accessor: "total_time_in_geofences", show: true, width: '15%' },
        { Header: "Total Distance", accessor: "total_distance", show: true, width: '8%' },
        { Header: "Total Duration", accessor: "total_duration", show: true, width: '8%' },
        { Header: "Run Time", accessor: "run_time", show: true, width: '5%' },
        { Header: "Pause Time", accessor: "pause_time", show: true, width: '7%' },
        { Header: "Fuel Used", accessor: "fuel_used", show: true, width: '7%' },
        {
            Header: "actions",
            disableSortBy: true,
            accessor: "actions",
            show: true,
            width: '5%'
        },
    ];
    const routeSubColumns = [
        { Header: "ID", accessor: "point_id", show: true, width: '5%', align: 'left' },
        { Header: "Status", accessor: "status", show: true, width: '5%', align: 'center' },
        { Header: "Latitude", accessor: "latitude", show: true, width: '8%', align: 'center' },
        { Header: "Longitude", accessor: "longitude", show: true, width: '8%', align: 'center' },
        { Header: "Speed", accessor: "speed", show: true, width: '5%', align: 'center' },
        {
            Header: "Heading",
            accessor: "heading",
            width: '5%', align: 'center',
            show: true,
        },
        { Header: "Geofence", accessor: "geofence_id", show: true, width: '8%', align: 'center' },
        { Header: "Geofence Event", accessor: "geofence_event_id", show: true, width: '15%', align: 'center' },
        { Header: "Ignition On", accessor: "ignition_on", show: true, width: '10%', align: 'center' },
        { Header: "RPM", accessor: "can_engine_rpm", show: true, width: '5%', align: 'center' },
        { Header: "Fuel Level", accessor: "can_fuel_level", show: true, width: '10%', align: 'center' },
        { Header: "MAP", accessor: "convert_can_intake_map", show: true, width: '5%', align: 'center' },
        { Header: "Engine Load", accessor: "can_engine_load_level", show: true, width: '10%', align: 'center' },
        { Header: "Throttle Level", accessor: "can_throttle_pedal_level", show: true, width: '15%', align: 'center' },
        { Header: "Intake Air Temp", accessor: "convert_can_intake_air_temperature", show: true, width: '18%', align: 'center' },
        { Header: "Coolant Temp", accessor: "convert_can_engine_coolant_temperature", show: true, width: '10%', align: 'center' },
        // { Header: "Vehicel vin", accessor: "vehicle_vin", show: true },
        { Header: "Place Location", accessor: "place_location", show: true, width: '15%', align: 'center' },
        { Header: "Place Type", accessor: "place_type", show: true, width: '15%', align: 'center' },
        { Header: "Timestamp", accessor: "timestamp", show: true, width: '15%', align: 'center' },
        {
            Header: "actions",
            disableSortBy: true,
            accessor: "actions",
            show: true,
            width: '5%', align: 'center'
        },
    ];

    const clickViewHandler = async (id, value) => {
        let data = await CrudService.getAlert(id);
        setAlert(data);
        setOpenViewModal(true);
    };

    const clickDeleteHandler = async (e, del_id) => {
        try {
            if (!confirm('Are you sure you want to delete this alert?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                await CrudService.deleteAlert(del_id)
                allAlerts(page, rowsPerPage)
                setNotification({
                    value: true,
                    text: 'The Alert has been successfully deleted',
                })
            }
        } catch (err) {
            console.error(err)
            if (err.hasOwnProperty('errors')) {
                setNotification({
                    value: true,
                    text: err.errors[0].detail,
                })
            }
            return null
        }
    }

    const clickExportHandler = async (id) => {
        try {
            const exportUrl = `${process.env.REACT_APP_API_URL}/modules/export_excel/${id}`;
            window.open(exportUrl, '_blank');
        } catch (error) {
            console.error('clickExportHandler error', error)
        }
    }

    const clickRouteViewHandler = async (data) => {
        try {
            setHighlightRouteData([])
            let resp = await CrudService.getTrackingPoint(data.route_id)
            if (resp?.success) {
                data.RouteTrackingPoints = resp.data
                setHighlightRouteData([{ ...data, selected: true }])
                uiPage.current?.scrollIntoView({ behavior: "smooth" });
            } else {
                toast.error('Something went wrong!')
            }
        } catch (error) {
            console.error('clickRouteViewHandler error', error)
        }
    }
    const clickSubRouteViewHandler = async (data) => {
        try {
            if (data) {
                setSelectedLogInfo(data.DeviceMonitorParameterValue)
            }
        } catch (error) {
            console.error('clickRouteViewHandler error', error)
        }
    }

    const closeHighlightRoute = () => setHighlightRouteData([])

    const clickRouteDeleteHandler = async (e, del_id) => {
        try {
            if (!confirm('Are you sure you want to delete this route?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                await CrudService.deleteRoutes(del_id)
                let today_routes = await CrudService.getTodayRoutes(id);
                if (today_routes?.success) {
                    setRouteData(today_routes.data.length > 0 ? [today_routes.data[0]] : today_routes.data);
                }
                let all_routes = await CrudService.getRoutes(id, page + 1, rowsPerPage);
                if (all_routes.success) {
                    setRouteAllData(all_routes.data);
                }
                setNotification({
                    value: true,
                    text: 'The Route has been successfully removed',
                })
            }
        } catch (err) {
            console.error(err)
            setNotification({
                value: true,
                text: err.error,
            })
            return null
        }
    }

    const removeLogs = async (e) => {
        try {
            if (!confirm('Are you sure you want to delete this logs?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                setLoaderT(true)
                await CrudService.removeMonitorDeviceParameterValue({ device_id: id, logs_id: selectedLogs });
                setNotification({
                    value: true,
                    text: 'The Device Logs has been successfully deleted',
                })
                setSelectedLogs([])
                await monitorLogs()
                setLoaderT(false)
            }
        } catch (err) {
            console.error(err)
            if (err.hasOwnProperty('error')) {
                setNotification({
                    value: true,
                    text: err.error,
                })
            }
            setLoaderT(false)
            return null
        }
    }

    const removeEvents = async (e) => {
        try {
            if (!confirm('Are you sure you want to delete this event?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                setLoaderTable(true)
                await CrudService.removeDeviceMultipleEvent(selectedEvent);
                allEvents()
                setNotification({
                    value: true,
                    text: 'The Events has been successfully deleted',
                })
                setSelectedEvent([])
                setLoaderTable(false)
            }
        } catch (err) {
            console.error(err)
            if (err.hasOwnProperty('errors')) {
                setNotification({
                    value: true,
                    text: err.errors,
                })
            }
            setLoaderTable(false)
            return null
        }
    }

    const handlePublicDeviceShare = async (e) => {
        try {
            if (!confirm('Are you sure you want to update this device share?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                let response = await CrudService.publicShareDevice({
                    device_id: id,
                    status: !isShare
                })
                setNotification({
                    value: true,
                    text: 'The Status has been successfully updated',
                })
                setShare(!isShare)
                if (response?.data) {
                    device.attributes.PublicShareDevice = response.data
                }
            }
        } catch (err) {
            console.error(err)
            if (err.hasOwnProperty('errors')) {
                setNotification({
                    value: true,
                    text: err.errors,
                })
            }
            return null
        }
    }

    const clickServiceReqeustRowHandler = (service_request_id) => {
        setServiceRequestId(service_request_id);
    };

    const handleExpand = (index) => {
        setExpandedIndexArray((prevArray) =>
            prevArray.map((item, idx) => (idx === index ? !item : item))
        );
    };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        localStorage.setItem("serviceRequestTab", newValue);
    };

    function copyToClipboard(text) {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.info("Copied!")
            })
            .catch((error) => {
                console.error("Failed to copy text:", error);
            });
    }

    const cardStyle = (index) => ({
        display: "flex",
        flexDirection: "column",
        ...(expandedIndexArray[index] && { minHeight: "100%" }),
    });

    const styles = devStyle(isTabletOrMobile)

    const handleViewClose = () => {
        setOpenViewModal(false);
    };
    const handleServiceRequestModalClose = () => {
        setServiceRequestLogModal(false);
    };

    const handleDeviceDisconnectModalClose = () => {
        setDeviceDisconnectModal(false);
    };

    const handleServiceModalClose = () => {
        setServiceModal(false);
    };

    // This function will handle the removal of the alert when clicked
    const handleClose = async (alertId, alertTypeId, deviceId) => {
        // Filter out the alert with the matching id
        const updatedAlerts = activeAlerts.filter(
            (alert) => alert.alert_id !== alertId
        );
        setActiveAlerts(updatedAlerts);
        const payload = {
            deviceId: deviceId,
            alertTypeId: alertTypeId,
        };
        await CrudService.updateNotificationStatus(payload);
    };

    const handleSelectedRows = (request_id, flag) => {
        if (
            serviceRequestEditFlag != true ||
            serviceRequestLogModal != true ||
            serviceRequestDeleteFlag != true
        ) {
            const firstSelectedServiceRequestId = getKeyWithSpecialValue(
                selectedRows,
                true
            );

            let serviceRequestType = "";
            if (firstSelectedServiceRequestId != undefined) {
                const selectedFirstRequest = serviceRequests.filter((request) => {
                    return (
                        request?.attributes?.service_request_id ==
                        firstSelectedServiceRequestId
                    );
                });
                if (selectedFirstRequest) {
                    const selectedRequestTypeTemp =
                        selectedFirstRequest[0]?.attributes.status_type_id;
                    serviceRequestType = selectedRequestTypeTemp;

                    setSelectedRequestType(selectedRequestTypeTemp);
                }
            } else {
                const firstRequest = serviceRequests.filter((request) => {
                    return request?.attributes?.service_request_id == request_id;
                });

                const firstRequestType = firstRequest[0]?.attributes?.status_type_id;
                serviceRequestType = firstRequestType;
            }

            const selectedServiceRequest = serviceRequests.filter((request) => {
                return request?.attributes?.service_request_id == request_id;
            });

            if (selectedServiceRequest) {
                if (
                    selectedServiceRequest[0]?.attributes?.status_type_id ==
                    serviceRequestType
                ) {
                    setSelectedRequestType(serviceRequestType);
                    setSelectedRows({
                        ...selectedRows,
                        [request_id]: flag,
                    });
                }
            }
        }
    };

    const getRouteTable = (info) => {
        let updatedInfo = info.map((row) => {

            if (row.start_group_id) {
                row['start_group'] = templateValuesList.filter((e) => e.condition_group_id == row.start_group_id)
            }
            if (row.end_group_id) {
                row['end_group'] = templateValuesList.filter((e) => e.condition_group_id == row.end_group_id)
            }

            const finalOutput = row?.RouteSummary?.geofence_entries ?? []

            const formatted = finalOutput.filter((e) => e.duration != '0m 0s')
                .map((f) => `${f.name}: ${f.duration}`)
                .join(", ");

            const formattedNames = finalOutput.filter((e) => e.duration != '0m 0s')
                .map(({ name }) => name)
                .join(", ");

            return {
                ...row,
                route_id: row?.route_id,
                status: row?.StatusType?.status_name,
                start_log_id: row?.start_log_id ?? '',
                end_log_id: row?.end_log_id ?? '',
                device_id: row?.device_id,
                start_time: row?.start_time ? moment(row?.start_time).format("MMMM DD, YYYY h:mm:ss A") : '',
                end_time: row?.end_latitude ? (row?.end_time ? moment(row?.end_time).format("MMMM DD, YYYY h:mm:ss A") : '') : '',
                start_latitude: row?.start_latitude ?? '',
                start_longitude: row?.start_longitude ?? '',
                end_latitude: row?.end_latitude ?? '',
                end_longitude: row?.end_longitude ?? '',
                total_distance: row?.total_distance ? `${convertUtils(row?.total_distance).from('km').to('mi').toFixed(2)} miles` : '',
                total_duration: row?.total_duration ? getDuration(row?.total_duration) : '',
                pause_time: row?.RouteSummary?.pause_time ?? '',
                run_time: row?.RouteSummary?.run_time ?? '',
                visited_geofences: formattedNames ?? '',
                total_time_in_geofences: formatted ?? '',
                fuel_used: row?.RouteSummary?.fuel_used ?? '',
            };
        });

        return updatedInfo;
    }

    const handleProviderSwitchChange = async (association_id, newOnOffValue) => {
        setProvidersState((prevState) =>
            prevState.map((provider) =>
                provider.association_id === association_id
                    ? { ...provider, on_off: newOnOffValue }
                    : provider
            )
        );

        try {
            await CrudService.setProviderActive({
                association_id,
                on_off: newOnOffValue,
                device_id: device.id,
            });
            const serviceRequestssRes = await CrudService.getServiceRequests(
                device?.attributes?.EntityAddressItem.address_item_id
            );
            setServiceRequests(serviceRequestssRes.data);
        } catch (error) {
            console.error("Error updating provider:", error);
        }
    };

    const checkAllNotification = (alerts) => {
        let isAllNotification = false;
        alerts.forEach((alert) => {
            if (alert?.AlertType?.category != "notice") {
                isAllNotification = true;
                return;
            }
        });
        return isAllNotification;
    };

    const openModalFn = (type) => {
        if (type == "device") {
            setGps({
                latitude: paramValue?.latitude,
                longitude: paramValue?.longitude,
            });
        } else if (type == "item") {
            setGps({
                latitude: deviceSetupFields?.latitude,
                longitude: deviceSetupFields?.longitude,
                edit: true,
            });
        } else if (type == "itemButton") {
            setGps({
                latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
                longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
                edit: true,
            });
        } else {
            setGps({
                latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
                longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
            });
        }
        setOpenModal(true);
    };

    const openLogs = (data, type) => {
        if (data && type) {
            setRawDataValue(data[type] ?? '')
            setJsonTree(true)
        }
    }

    const clickInfoHandler = (data) => {
        if (data.start_group || data.end_group) {
            setSelectedRouteGroup({
                start: data?.start_group,
                end: data?.end_group,
                route_id: data.route_id,
                analysis: data?.RouteAnalysis,
                startRouteLog: data?.StartLog,
                endRouteLog: data?.EndLog
            })
        } else {
            window.alert('No data')
        }
    }

    const clickLogInfoHandler = (e, data) => {
        e.stopPropagation()
        if (data) {
            setSelectedLogInfo(data)
        } else {
            window.alert('No data')
        }
    }

    async function resetCounter(e, parameter_name) {
        e.stopPropagation();
        if (confirm('Are you sure you want to reset the counter?')) {
            try {
                let resp = await CrudService.resetTrackingCounter(id, parameter_name)
                if (resp?.success) {
                    setTrackingCounter({
                        ...trackingCounter,
                        [parameter_name]: 0
                    })
                    toast.success('Counter reset successfully')
                }
            } catch (error) {
                console.error('resetTracker error', error)
            }
        }
    }

    return (
        <DashboardLayout>
            <DashboardNavbar title={navbarTitle} titleIcon={titleIcon} />
            {notification.value && (
                <MDAlert
                    color={notification.bgColor}
                    my="20px"
                    sx={{
                        position: "sticky",
                        top: { md: "100px", xs: "50px" },
                        zIndex: "10000",
                    }}
                >
                    <MDTypography variant="body2" color="white">
                        {notification.text || ""}
                    </MDTypography>
                </MDAlert>
            )}

            <MDBox mt={0} mb={9} ref={uiPage}>
                <Grid justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={0} mb={0} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    {titleIcon ? <i className={titleIcon} style={{ fontSize: "24px" }}></i> : ''} {device?.attributes?.name}{" "}
                                    {activeAlerts.length != 0 &&
                                        checkAllNotification(activeAlerts) ? (
                                        // <i
                                        //     className="fas fa-triangle-exclamation"
                                        //     style={{ fontSize: "24px", color: "#d32f2f" }}
                                        // ></i>
                                        <i
                                            className={activeAlerts[0].AlertType?.Icon?.class_name ?? "fas fa-triangle-exclamation"}
                                            style={{ fontSize: "24px", color: `${activeAlerts[0]?.AlertType?.BadgeDetail?.font_color_hex ?? "#d32f2f"}` }}
                                        ></i>
                                    ) : (
                                        ""
                                    )}
                                </MDTypography>
                                {activeAlerts.map((alert) => (
                                    <div
                                        key={alert?.alert_id}
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid ${alert?.AlertType?.BadgeDetail?.border_color_hex ?? "green"}`,
                                            alignItems: "center",
                                            backgroundColor: alert?.AlertType?.BadgeDetail?.background_color_hex ?? "#d1ffd6",
                                        }}
                                    >
                                        {/* Close button */}
                                        {alert?.AlertType?.category == "notice" && (
                                            <button
                                                style={{
                                                    position: "absolute",
                                                    top: "5px",
                                                    right: "5px",
                                                    background: "transparent",
                                                    border: "none",
                                                    fontSize: "16px",
                                                    cursor: "pointer",
                                                    color: "black",
                                                }}
                                                onClick={() =>
                                                    handleClose(
                                                        alert?.alert_id,
                                                        alert?.alert_type_id,
                                                        alert?.device_id
                                                    )
                                                } // Replace with your close function
                                            >
                                                &times;
                                            </button>
                                        )}
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color: alert?.AlertType?.BadgeDetail?.font_color_hex ?? "green",
                                                marginLeft: "10px",
                                            }}
                                        >
                                            <i
                                                className={alert?.AlertType?.Icon?.class_name}
                                                style={{
                                                    marginRight: "5px",
                                                    fontSize: "16px",
                                                    color: alert?.AlertType?.BadgeDetail?.font_color_hex ?? "green",
                                                }}
                                            ></i>{" "}
                                            {alert?.AlertType?.type_name} -{" "}
                                            {alert?.AlertType?.description} &middot;{" "}
                                            {moment(alert?.created_at).format(
                                                "MMMM Do YYYY, h:mm:ss A"
                                            )}
                                        </MDTypography>
                                    </div>
                                ))}
                                {
                                    activeServiceRequest &&
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid ${activeServiceRequest?.StatusOption?.BadgeDetail?.font_color ?? 'green'}`,
                                            alignItems: "center",
                                            backgroundColor: serviceRequestStatusColor(activeServiceRequest?.StatusOption?.BadgeDetail?.color),
                                        }}
                                    >
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color: activeServiceRequest?.StatusOption?.BadgeDetail?.font_color ?? 'green',
                                                marginLeft: "10px",
                                            }}
                                        >
                                            {'Service ' + activeServiceRequest?.StatusOption?.StatusType?.status_name} -{" "}
                                            {activeServiceRequest?.StatusOption?.StatusType?.description} &middot;{" "}
                                            {moment(activeServiceRequest?.created_at).format(
                                                "MMMM Do YYYY, h:mm:ss A"
                                            )}
                                        </MDTypography>
                                    </div>
                                }
                                {
                                    notifyAlert &&
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid yellow`,
                                            alignItems: "center",
                                            backgroundColor: '#ffff00ba'
                                            // backgroundColor: serviceRequestStatusColor(activeServiceRequest?.StatusOption?.BadgeDetail?.color),
                                        }}
                                    >
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color: 'white',
                                                marginLeft: "10px",
                                            }}
                                        >
                                            <i
                                                className='fa fa-bell'
                                                style={{
                                                    marginRight: "5px",
                                                    fontSize: "16px",
                                                    color: "#fff",
                                                }}
                                            ></i>{" "}
                                            {notifyAlert}
                                        </MDTypography>
                                    </div>
                                }
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox>
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                                    <MDBox mb={3}>
                                        {
                                            (![null, undefined, ''].includes(gpsData.latitude) && ![null, undefined, ''].includes(gpsData.longitude)) ?
                                                (highlightRouteData.length > 0 ?
                                                    <AssetTrackerMapPrevRouteView mapIcon={mapIcon} icons={icons} routeData={highlightRouteData} closeHighlightRoute={closeHighlightRoute} activeAlerts={activeAlerts} /> :
                                                    <AssetTrackerMap latitude={gpsData.latitude} longitude={gpsData.longitude} heading={gpsData.heading} mapIcon={mapIcon} ignoreHeading={ignoreHeading} gpsStatus={gpsStatus} icons={icons} routeData={routeData} closeHighlightRoute={closeHighlightRoute} activeAlerts={activeAlerts} geofence={geofence} paramValue={paramValue} />)
                                                : <></>
                                        }
                                    </MDBox>
                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                {
                                                    title: "Device Information",
                                                    icon: "fas fa-info-circle",
                                                },
                                                { title: "Current Data", icon: "fas fa-chart-line" },
                                                { title: "Monitor", icon: "fas fa-tachometer-alt" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index}>
                                                    <Card style={cardStyle(index)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index)}
                                                        />
                                                        {expandedIndexArray[index] && (
                                                            <CardContent
                                                                style={
                                                                    isTabletOrMobile
                                                                        ? { padding: "16px", flex: 1 }
                                                                        : { flex: 1 }
                                                                }
                                                            >
                                                                {index === 0 && (
                                                                    <>
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                justifyContent: "end",
                                                                                mb: 2,
                                                                            }}
                                                                        >
                                                                            <MDButton
                                                                                variant="gradient"
                                                                                color="dark"
                                                                                size="small"
                                                                                px={2}
                                                                                mx={2}
                                                                                onClick={() => {
                                                                                    handleOpenDeviceInfoEditModal();
                                                                                }}
                                                                            >
                                                                                Edit
                                                                            </MDButton>
                                                                        </Box>
                                                                        {!loader ? (
                                                                            <Table
                                                                                style={{
                                                                                    ...styles.table,
                                                                                    marginTop: "5px",
                                                                                    boxShadow:
                                                                                        "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                }}
                                                                            >
                                                                                <TableBody>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Device Name:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {name?.text}
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Device Type:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes?.DeviceType
                                                                                                        ?.type_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Brand:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.DeviceBrand?.brand_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Model:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.DeviceModel?.model_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Item?.ItemType?.type_name ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Item Type Name:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Item
                                                                                                                ?.ItemType?.type_name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>
                                                                                                    Entity Address Item Id:
                                                                                                </strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes?.EntityAddressItem?.address_item_id
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Address?.address_id ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>
                                                                                                            Entity Address Id:
                                                                                                        </strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Address
                                                                                                                ?.address_id
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.name ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Item Name:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Item?.name ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Item Type:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Item
                                                                                                                ?.name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Address ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Address Name:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Address
                                                                                                                ?.name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    {
                                                                                        device?.attributes?.EntityAddressItem?.Address ?
                                                                                            <TableRow>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Address:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell style={styles.cell}>
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {[
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Address
                                                                                                                ?.street_address1,
                                                                                                            device?.attributes
                                                                                                                ?.EntityAddressItem?.Address
                                                                                                                ?.street_address2,
                                                                                                            [
                                                                                                                device?.attributes
                                                                                                                    ?.EntityAddressItem
                                                                                                                    ?.Address?.city,
                                                                                                                device?.attributes
                                                                                                                    ?.EntityAddressItem
                                                                                                                    ?.Address?.state,
                                                                                                                device?.attributes
                                                                                                                    ?.EntityAddressItem
                                                                                                                    ?.Address?.postal_code,
                                                                                                            ]
                                                                                                                .filter(Boolean)
                                                                                                                .join(", "),
                                                                                                        ]
                                                                                                            .filter(Boolean)
                                                                                                            .join(", ")}
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow> : <></>
                                                                                    }
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Status / Mode:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.StatusOption?.StatusType
                                                                                                        ?.status_name
                                                                                                } / {
                                                                                                    selectedMode?.mode_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    {deviceSetupFields?.latitude && (
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Item Latitude:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    ...styles.cell,
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    openModalFn("item")
                                                                                                }
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <a>
                                                                                                        {
                                                                                                            deviceSetupFields?.latitude
                                                                                                        }
                                                                                                    </a>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )}
                                                                                    {deviceSetupFields?.longitude && (
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Item Longitude:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    ...styles.cell,
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    openModalFn("item")
                                                                                                }
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <a>
                                                                                                        {
                                                                                                            deviceSetupFields?.longitude
                                                                                                        }
                                                                                                    </a>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        {
                                                                            window.innerWidth > 600 ?
                                                                                <Box
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        justifyContent: "end",
                                                                                        mb: 5.5,
                                                                                    }}
                                                                                ></Box> : <></>
                                                                        }
                                                                        {loader && <StackSkeleton />}

                                                                        <Table
                                                                            style={{
                                                                                ...styles.table,
                                                                                marginTop: "5px",
                                                                                boxShadow:
                                                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                            }}
                                                                        >
                                                                            <TableBody>
                                                                                {(!loader && parameters.length && paramValue) ? (
                                                                                    parameters.map((e) => {
                                                                                        if (show_current_data.includes(e.parameter_name) && !cond.includes(paramValue[e.parameter_name]) && canContinueCurrentData(paramValue, e.parameter_name)) {
                                                                                            return (
                                                                                                <React.Fragment key={e.parameter_name}>
                                                                                                    <TableRow key={e.parameter_name}>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                            title={e.tooltip}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                                    {e.Icon ? <i className={e.Icon.class_name}></i> : ''}
                                                                                                                    {e.label}:
                                                                                                                </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {formatValue(paramValue[`convert_${e.parameter_name}`] ?? paramValue[e.parameter_name], e.format ?? '', e.display_ui ?? '')}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                    <DisplayGeofenceLocation parameter_name={e.parameter_name} geofence={geofence} geofenceIcon={geofenceIcon} styles={styles} />
                                                                                                </React.Fragment>
                                                                                            );
                                                                                        }
                                                                                        return <></>;
                                                                                    })
                                                                                ) : ''}
                                                                                {(!loader && parameters.length && trackingCounter) ? (
                                                                                    parameters.map((e) => {
                                                                                        if (counter_data.includes(e.parameter_name) && !cond.includes(trackingCounter[e.parameter_name])) {
                                                                                            return (
                                                                                                <React.Fragment key={e.parameter_name}>
                                                                                                    <TableRow key={e.parameter_name}>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                            title={e.tooltip}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                                    {e.Icon ? <i className={e.Icon.class_name}></i> : ''}
                                                                                                                    {e.label}:
                                                                                                                </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {e.parameter_name == 'current_mileage' ? formatValue(trackingCounter[e.parameter_name], e.format ?? '', e.display_ui ?? '') : formatDuration(trackingCounter[e.parameter_name])}
                                                                                                                {
                                                                                                                    ['current_mileage', 'current_ignition_seconds'].includes(e.parameter_name) && trackingCounter?.[e.parameter_name] != 0 ?
                                                                                                                        <>
                                                                                                                            &nbsp;&nbsp;
                                                                                                                            <HistoryIcon sx={{ cursor: 'pointer' }} onClick={(event) => resetCounter(event, e.parameter_name)} />
                                                                                                                        </>
                                                                                                                        : ''
                                                                                                                }
                                                                                                            </MDTypography>

                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                    <DisplayGeofenceLocation parameter_name={e.parameter_name} geofence={geofence} geofenceIcon={geofenceIcon} styles={styles} />
                                                                                                </React.Fragment>
                                                                                            );
                                                                                        }
                                                                                        return <></>;
                                                                                    })
                                                                                ) : ''}
                                                                                {
                                                                                    linkedDeviceData.length > 0 &&
                                                                                    linkedDeviceData.map((value) => (
                                                                                        <LinkedDeviceView data={value} styles={styles} />
                                                                                    ))
                                                                                }
                                                                            </TableBody>
                                                                        </Table>
                                                                    </>
                                                                )}
                                                                {index === 2 && (
                                                                    <>
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                            }}
                                                                        >
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Switch
                                                                                        checked={isNotified}
                                                                                        onChange={(e) => {
                                                                                            setNotified(!isNotified);
                                                                                            CrudService.setDeviceAlertEnable({
                                                                                                deviceId: id,
                                                                                                is_notified: !isNotified,
                                                                                            });
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                label="Alerts Enabled"
                                                                                mt={5}
                                                                                mb={5}
                                                                            />
                                                                            <MDButton
                                                                                variant="gradient"
                                                                                color="dark"
                                                                                size="small"
                                                                                px={2}
                                                                                mx={2}
                                                                                onClick={handleOpenMonitorEditModal}
                                                                            >
                                                                                Edit
                                                                            </MDButton>
                                                                        </Box>
                                                                        {loader && <StackSkeleton />}
                                                                        {!loader && (
                                                                            <MDBox>
                                                                                <table className="table table-borderless">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <RenderTR
                                                                                                th={"Name"}
                                                                                                td={device?.monitor}
                                                                                                styles={styles}
                                                                                            />
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_status
                                                                                                ?.StatusType?.status_name && (
                                                                                                    <RenderTR
                                                                                                        th={"Status"}
                                                                                                        styles={styles}
                                                                                                        td={
                                                                                                            <Badge
                                                                                                                color={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.BadgeDetail
                                                                                                                        ?.color || "primary"
                                                                                                                }
                                                                                                                variant={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.BadgeDetail?.variant
                                                                                                                }
                                                                                                                badgeContent={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.StatusType
                                                                                                                        ?.status_name
                                                                                                                }
                                                                                                                style={{
                                                                                                                    marginLeft: "30px",
                                                                                                                }}
                                                                                                            ></Badge>
                                                                                                        }
                                                                                                    />
                                                                                                )}
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_frequency && (
                                                                                                <RenderTR
                                                                                                    th={"Frequency"}
                                                                                                    styles={styles}
                                                                                                    td={`${device?.monitor_frequency ??
                                                                                                        ""
                                                                                                        } ${device?.monitor_time_unit ??
                                                                                                        ""
                                                                                                        }`}
                                                                                                />
                                                                                            )}
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_last_updated && (
                                                                                                <RenderTR
                                                                                                    th={"Last Updated"}
                                                                                                    styles={styles}
                                                                                                    td={moment(
                                                                                                        device?.monitor_last_updated
                                                                                                    ).format(
                                                                                                        "MMMM Do YYYY, h:mm:ss a"
                                                                                                    )}
                                                                                                />
                                                                                            )}
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>

                                                                                {device?.deviceThresholds.map(
                                                                                    (threshold, thresholdIndex) => (
                                                                                        <Table
                                                                                            key={thresholdIndex + 3}
                                                                                            style={{
                                                                                                ...styles.table,
                                                                                                marginTop: "5px",
                                                                                                boxShadow:
                                                                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                            }}
                                                                                        >
                                                                                            <TableBody>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Alert Type:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold?.AlertType
                                                                                                                    ?.type_name
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Parameter
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold
                                                                                                                    ?.DeviceParameter
                                                                                                                    ?.label
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Comparison Operator:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold
                                                                                                                    ?.ComparisonOperator
                                                                                                                    ?.label
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Threshold Comparison
                                                                                                                Value:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold?.ui_display ?? threshold?.threshold_value
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    )
                                                                                )}
                                                                            </MDBox>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>

                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                { title: "Transmission", icon: "fas fa-signal" },
                                                { title: "Device Signal", icon: "fas fa-chart-diagram" },
                                                { title: "Providers", icon: "fas fa-truck" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index + 3}>
                                                    <Card style={cardStyle(index + 3)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index + 3)}
                                                        />
                                                        {expandedIndexArray[index + 3] && (
                                                            <CardContent style={{ flex: 1 }}>
                                                                {index === 0 && (
                                                                    <>
                                                                        {!loader ? (
                                                                            <Table
                                                                                style={{
                                                                                    ...styles.table,
                                                                                    marginTop: "5px",
                                                                                    boxShadow:
                                                                                        "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                }}
                                                                            >
                                                                                <TableBody>
                                                                                    {!loader && (
                                                                                        <>
                                                                                            {(!loader && parameters.length && paramValue) ? (
                                                                                                parameters.map((e) => (
                                                                                                    show_transmission_data.includes(e.parameter_name) && !cond.includes(paramValue[e.parameter_name]) &&
                                                                                                    <TableRow key={e.parameter_name}>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                            title={e.tooltip}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                                    {e.Icon ? <i className={e.Icon.class_name}></i> : ''}
                                                                                                                    {e.label}:
                                                                                                                </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {formatValue(paramValue[e.parameter_name], e.format ?? '', e.display_ui ?? '')}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                ))
                                                                                            ) : ''}
                                                                                            {(reporting) ? (
                                                                                                <>
                                                                                                    <TableRow>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong>Reported: </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {
                                                                                                                    moment(+`${reporting}000`).format("MMM Do YYYY, h:mm A")
                                                                                                                }
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                    <TableRow>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong>Last Updated: </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {
                                                                                                                    moment(reporting * 1000).fromNow()
                                                                                                                }
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                </>
                                                                                            ) : <> </>}
                                                                                            {
                                                                                                paramValue?.report_reason ?
                                                                                                    <TableRow>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                <strong>Report Type: </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography fontSize={1}>
                                                                                                                {reportType[paramValue?.report_reason]}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                    : <></>
                                                                                            }
                                                                                        </>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        {loader && <StackSkeleton />}

                                                                        <Table
                                                                            style={{
                                                                                ...styles.table,
                                                                                marginTop: "5px",
                                                                                boxShadow:
                                                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                            }}
                                                                        >
                                                                            <TableBody>
                                                                                {(!loader && parameters.length && paramValue) ? (
                                                                                    parameters.map((e) => (
                                                                                        show_device_signal_data.includes(e.parameter_name) && !cond.includes(paramValue[e.parameter_name]) &&
                                                                                        <React.Fragment key={e.parameter_name}>
                                                                                            {
                                                                                                e.parameter_name == 'din_1' ? <h5 style={deviceSignalSubHeaderStyle}>Digital Input</h5> : ''
                                                                                            }
                                                                                            {
                                                                                                e.parameter_name == 'dout_1' ? <h5 style={deviceSignalSubHeaderStyle}>Digital Output</h5> : ''
                                                                                            }
                                                                                            {
                                                                                                e.parameter_name == 'ain_0' ? <h5 style={deviceSignalSubHeaderStyle}>Analog Input</h5> : ''
                                                                                            }
                                                                                            <TableRow key={e.parameter_name}>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                    title={e.tooltip}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                            {e.Icon ? <i className={e.Icon.class_name}></i> : ''}
                                                                                                            {e.label}:
                                                                                                        </strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {
                                                                                                            typeof paramValue[e.parameter_name] == 'boolean' ?
                                                                                                                <Badge
                                                                                                                    color={paramValue[e.parameter_name] ? 'success' : 'error'}
                                                                                                                    variant={'standard'}
                                                                                                                    badgeContent={formatValueForSignal(paramValue[e.parameter_name])}
                                                                                                                    style={{ marginLeft: "30px" }}
                                                                                                                ></Badge>
                                                                                                                :
                                                                                                                paramValue[e.parameter_name]
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        </React.Fragment>
                                                                                    ))
                                                                                ) : ''}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </>
                                                                )}

                                                                {index === 2 && (
                                                                    <>
                                                                        <MDBox>
                                                                            <Grid
                                                                                container
                                                                                justifyContent="space-between"
                                                                            >
                                                                                <Grid item>
                                                                                    <MDTypography variant="h6">
                                                                                        Provider
                                                                                    </MDTypography>
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <MDTypography variant="h6" mr={3}>
                                                                                        Share
                                                                                    </MDTypography>
                                                                                </Grid>
                                                                            </Grid>
                                                                            {!loader ? (
                                                                                <>
                                                                                    {device?.entityAddressItemProviders.map(
                                                                                        (provider) => (
                                                                                            <MDBox
                                                                                                key={provider?.association_id}
                                                                                                sx={{
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent:
                                                                                                        "space-between",
                                                                                                    width: "100%",
                                                                                                }}
                                                                                            >
                                                                                                <MDBox
                                                                                                    sx={{
                                                                                                        display: "flex",
                                                                                                        alignItems: "center",
                                                                                                    }}
                                                                                                >
                                                                                                    <Avatar
                                                                                                        src={
                                                                                                            provider?.Provider
                                                                                                                ?.logo_url
                                                                                                        }
                                                                                                        alt={
                                                                                                            provider?.Provider
                                                                                                                ?.provider_name
                                                                                                        }
                                                                                                        sx={{
                                                                                                            width: 60,
                                                                                                            height: 60,
                                                                                                        }}
                                                                                                    />
                                                                                                    <MDTypography ml={2}>
                                                                                                        {
                                                                                                            provider?.Provider
                                                                                                                ?.provider_name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </MDBox>
                                                                                                <FormControlLabel
                                                                                                    control={
                                                                                                        <Switch
                                                                                                            checked={
                                                                                                                providersState.find(
                                                                                                                    (p) =>
                                                                                                                        p.association_id ===
                                                                                                                        provider.association_id
                                                                                                                )?.on_off
                                                                                                            }
                                                                                                            onChange={async (e) => {
                                                                                                                const newOnOffValue =
                                                                                                                    e.target.checked;
                                                                                                                await handleProviderSwitchChange(
                                                                                                                    provider.association_id,
                                                                                                                    newOnOffValue
                                                                                                                );
                                                                                                            }}
                                                                                                        />
                                                                                                    }
                                                                                                    label=""
                                                                                                    sx={{
                                                                                                        mt: 5,
                                                                                                        mb: 5,
                                                                                                    }}
                                                                                                />
                                                                                            </MDBox>
                                                                                        )
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <StackSkeleton />
                                                                            )}
                                                                        </MDBox>
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>

                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                {
                                                    title: "Contact Detail",
                                                    icon: "fas fa-address-book",
                                                },
                                                {
                                                    title: "Device Setup",
                                                    icon: "fas fa-wrench",
                                                },
                                                { title: "Actions", icon: "fas fa-cogs" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index + 6}>
                                                    <Card style={cardStyle(index + 6)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index + 6)}
                                                        />
                                                        {expandedIndexArray[index + 6] && (
                                                            <CardContent
                                                                style={{
                                                                    flex: 1,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                }}
                                                            >
                                                                {index === 0 && (
                                                                    <>
                                                                        {
                                                                            checkAccess() &&
                                                                            <Box
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    justifyContent: "end",
                                                                                }}
                                                                            >
                                                                                <MDButton
                                                                                    variant="gradient"
                                                                                    color="dark"
                                                                                    size="small"
                                                                                    px={2}
                                                                                    mx={2}
                                                                                    onClick={
                                                                                        handleOpenContactsDetailsEditModal
                                                                                    }
                                                                                >
                                                                                    Edit
                                                                                </MDButton>
                                                                            </Box>
                                                                        }
                                                                        {!loader ? (
                                                                            <>
                                                                                {device &&
                                                                                    device.contacts &&
                                                                                    device.contacts.map(
                                                                                        (contact, contactindex) => (
                                                                                            <MDBox key={contactindex + 6}>
                                                                                                <Table
                                                                                                    style={{
                                                                                                        ...styles.table,
                                                                                                        marginTop: "5px",
                                                                                                        boxShadow:
                                                                                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                                    }}
                                                                                                >
                                                                                                    <TableBody>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Contact Name:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {`${contact?.Contact?.first_name} ${contact?.Contact?.last_name}`}
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Access Type:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {
                                                                                                                        contact?.access_type?.toUpperCase()
                                                                                                                    }
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Status:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {
                                                                                                                        contact?.Contact
                                                                                                                            ?.StatusOption
                                                                                                                            ?.StatusType
                                                                                                                            ?.status_name
                                                                                                                    }
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        {contact?.Contact
                                                                                                            ?.ContactAddresses &&
                                                                                                            contact?.Contact?.ContactAddresses.map(
                                                                                                                (address, subindex) => (
                                                                                                                    <TableRow
                                                                                                                        key={subindex + 6}
                                                                                                                    >
                                                                                                                        <TableCell
                                                                                                                            style={
                                                                                                                                styles.cell
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <MDTypography
                                                                                                                                fontSize={1}
                                                                                                                            >
                                                                                                                                <span
                                                                                                                                    style={{
                                                                                                                                        fontWeight:
                                                                                                                                            "700",
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {" "}
                                                                                                                                    {
                                                                                                                                        address
                                                                                                                                            ?.ContactAddressType
                                                                                                                                            ?.type_name
                                                                                                                                    }
                                                                                                                                    :{" "}
                                                                                                                                </span>
                                                                                                                            </MDTypography>
                                                                                                                        </TableCell>
                                                                                                                        <TableCell
                                                                                                                            style={
                                                                                                                                styles.cell
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <MDTypography
                                                                                                                                fontSize={1}
                                                                                                                            >
                                                                                                                                {
                                                                                                                                    address?.contact_address
                                                                                                                                }
                                                                                                                            </MDTypography>
                                                                                                                        </TableCell>
                                                                                                                    </TableRow>
                                                                                                                )
                                                                                                            )}
                                                                                                    </TableBody>
                                                                                                </Table>
                                                                                            </MDBox>
                                                                                        )
                                                                                    )}
                                                                            </>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        {/* <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                justifyContent: "end",
                                                                            }}
                                                                        >
                                                                            <MDButton
                                                                                variant="gradient"
                                                                                color="dark"
                                                                                size="small"
                                                                                px={2}
                                                                                mx={2}
                                                                                onClick={handleOpenDeviceSetupEditModal}
                                                                            >
                                                                                Edit
                                                                            </MDButton>
                                                                        </Box> */}
                                                                        <MDBox>
                                                                            {!loader ? (
                                                                                <Table
                                                                                    style={{
                                                                                        ...styles.table,
                                                                                        marginTop: "5px",
                                                                                        boxShadow:
                                                                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                    }}
                                                                                >
                                                                                    <TableBody>
                                                                                        {/* Render Device Setup Fields */}
                                                                                        {[
                                                                                            {
                                                                                                label: "External ID",
                                                                                                value:
                                                                                                    device?.external_device_id,
                                                                                            },
                                                                                            {
                                                                                                label: "Reference ID",
                                                                                                value: paramValue?.id,
                                                                                            },
                                                                                            {
                                                                                                label: "Depth",
                                                                                                value: deviceSetupFields?.depth,
                                                                                            },
                                                                                            {
                                                                                                label: "Shape",
                                                                                                value: deviceSetupFields?.shape,
                                                                                            },
                                                                                            {
                                                                                                label: "Width",
                                                                                                value: deviceSetupFields?.width,
                                                                                            },
                                                                                            {
                                                                                                label: "Length",
                                                                                                value:
                                                                                                    deviceSetupFields?.length,
                                                                                            },
                                                                                        ].map(
                                                                                            (field, index) =>
                                                                                                field.value && (
                                                                                                    <TableRow
                                                                                                        key={`setup-${index}`}
                                                                                                    >
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                <span
                                                                                                                    style={{
                                                                                                                        fontWeight: "700",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {field.label}:
                                                                                                                </span>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                {field.value}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                )
                                                                                        )}

                                                                                        {/* Render Device Identifier Values */}
                                                                                        {device.attributes?.DeviceIdentifierValues?.map(
                                                                                            (e, i) => (
                                                                                                <TableRow
                                                                                                    key={`identifier-${i}`}
                                                                                                >
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    e.DeviceIdentifierType
                                                                                                                        .identifier_type_name
                                                                                                                }
                                                                                                                :
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {e.value}
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )
                                                                                        )}

                                                                                        <TableRow>
                                                                                            <TableCell
                                                                                                style={styles.cell}
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <span
                                                                                                        style={{
                                                                                                            fontWeight: "700",
                                                                                                        }}
                                                                                                    >
                                                                                                        Public Share Device:
                                                                                                    </span>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={styles.cell}
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    {/* {device.attributes?.PublicShareDevice} */}
                                                                                                    <Switch
                                                                                                        checked={isShare}
                                                                                                        onChange={(e) => {
                                                                                                            handlePublicDeviceShare(e)
                                                                                                        }}
                                                                                                        title={isShare ? 'Public sharing is enabled' : 'Enable public sharing to generate a shareable link'}
                                                                                                    />
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                        {
                                                                                            isShare ?
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                Public Share Device URL:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1} style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(`${location.origin}/device/public/${device.attributes?.PublicShareDevice?.public_uuid}`)}>
                                                                                                            🔗
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                : <></>
                                                                                        }

                                                                                    </TableBody>
                                                                                </Table>
                                                                            ) : (
                                                                                <StackSkeleton />
                                                                            )}
                                                                        </MDBox>
                                                                    </>
                                                                )}
                                                                {index === 2 && (
                                                                    <>
                                                                        <MDButton
                                                                            color="dark"
                                                                            onClick={() => {
                                                                                setServiceRequestEditFlag(false);
                                                                                setServiceModal(true);
                                                                                setServiceRequest(null);
                                                                            }}
                                                                        >
                                                                            Create Service Request
                                                                        </MDButton>
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>
                                    <Modal
                                        open={openViewModal}
                                        onClose={handleViewClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: "80%", // Set the desired width here
                                                backgroundColor: "white",
                                                p: 4,
                                            }}
                                        >
                                            <AlertRulesForm
                                                alertRule={alertRule}
                                                setAlertRules={(data) => updateNewRules(data)}
                                                deviceId={id}
                                                setOpenViewModal={setOpenViewModal}
                                            />
                                        </Card>
                                    </Modal>
                                    {/* multi status edit modal */}
                                    <Modal
                                        open={multiStatusEditModal}
                                        onClose={handleCloseMultiStatusEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "40%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <MultiSeviceRequestStatusEditForm
                                                selectedRowsIdArray={selectedRowsIdArray}
                                                setMultiStatusEditModal={setMultiStatusEditModal}
                                                serviceRequestId={serviceRequestId}
                                                setDataTableUpdate={setDataTableUpdate}
                                                selectedRequestType={selectedRequestType}
                                                showToast={showToast}
                                                totalServiceRequestManagement={false}
                                            />
                                        </Card>
                                    </Modal>
                                    <Modal
                                        open={openMonitorEditModal}
                                        onClose={handleCloseMonitorEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "70%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <MDBox
                                                component="form"
                                                method="POST"
                                                onSubmit={handleSubmitMonitorEdit}
                                            >
                                                <Thresholds
                                                    selectedThresholds={selectedThresholds}
                                                    setSelectedThresholds={setSelectedThresholds}
                                                    type="edit"
                                                    model_id={device?.attributes?.DeviceModel?.model_id}
                                                    setRequiredThresholds={setRequiredThresholds}
                                                />
                                                <MDBox
                                                    ml="auto"
                                                    mt={3}
                                                    display="flex"
                                                    justifyContent="flex-end"
                                                >
                                                    <MDButton
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={handleCloseMonitorEditModal}
                                                    >
                                                        Cancel
                                                    </MDButton>
                                                    <MDButton
                                                        variant="contained"
                                                        color="info"
                                                        type="submit"
                                                        style={{ marginLeft: "10px" }}
                                                    >
                                                        Save
                                                    </MDButton>
                                                </MDBox>
                                            </MDBox>
                                        </Card>
                                    </Modal>
                                    <Modal
                                        open={openDeviceSetupEditModal}
                                        onClose={handleCloseDeviceSetupEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "40%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "1rem",
                                                }}
                                            >
                                                <TextField
                                                    label="Depth"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.depth}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            depth: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <TextField
                                                    label="Shape"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.shape}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            shape: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <TextField
                                                    label="Width"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.width}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            width: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <TextField
                                                    label="Length"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.length}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            length: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>
                                            <MDBox mt={3} display="flex" justifyContent="flex-end">
                                                <MDButton
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={handleCloseDeviceSetupEditModal}
                                                >
                                                    Cancel
                                                </MDButton>
                                                <MDButton
                                                    variant="contained"
                                                    color="info"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={handleSubmitDeviceSetupEdit}
                                                >
                                                    Save
                                                </MDButton>
                                            </MDBox>
                                        </Card>
                                    </Modal>

                                    <Modal
                                        open={openDeviceInfoEditModal}
                                        onClose={handleCloseDeviceInfoEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "40%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "1rem",
                                                }}
                                            >
                                                <TextField
                                                    label="Device Name"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceName}
                                                    onChange={(e) =>
                                                        setDeviceName(e.target.value)
                                                    }
                                                />
                                                <TextField
                                                    label="Latitude"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.latitude}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            latitude: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <TextField
                                                    label="Longitude"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={deviceSetupFields.longitude}
                                                    onChange={(e) =>
                                                        setDeviceSetupFields((prev) => ({
                                                            ...prev,
                                                            longitude: e.target.value,
                                                        }))
                                                    }
                                                />
                                                <TextField
                                                    label="Map Identifier"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={mapIdentifier}
                                                    onChange={(e) =>
                                                        setMapIdentifier(e.target.value)
                                                    }
                                                />
                                                <Autocomplete
                                                    defaultValue=""
                                                    options={modelist}
                                                    getOptionLabel={(option) =>
                                                        option ? option.mode_name : ''
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.mode_name === value}
                                                    value={selectedMode ?? ''}
                                                    onChange={(event, newMode) => {
                                                        setSelectedMode(newMode)
                                                    }}
                                                    renderInput={(params) => (
                                                        <FormField
                                                            {...params}
                                                            label="Mode"
                                                            variant="outlined"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            required
                                                        />
                                                    )}
                                                />
                                                <Autocomplete
                                                    defaultValue=""
                                                    options={iconList}
                                                    getOptionLabel={(option) =>
                                                        option ? option.class_name : ''
                                                    }
                                                    isOptionEqualToValue={(option, value) => option.class_name === value}
                                                    value={selectedIcon ?? ''}
                                                    onChange={(event, newIcon) => {
                                                        setSelectedIcon(newIcon)
                                                    }}
                                                    renderOption={(props, option) => {
                                                        const { key, ...optionProps } = props;
                                                        return (
                                                            <Box key={key} component="li" {...optionProps}>
                                                                <i className={option.class_name} style={{ paddingRight: '5px' }}></i>
                                                                {option.icon_name}
                                                            </Box>
                                                        );
                                                    }}
                                                    renderInput={(params) => (
                                                        <FormField
                                                            {...params}
                                                            label="Icon"
                                                            variant="outlined"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            required
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <MDBox mt={3} display="flex" justifyContent="flex-end">
                                                <MDButton
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={handleCloseDeviceInfoEditModal}
                                                >
                                                    Cancel
                                                </MDButton>
                                                <MDButton
                                                    variant="contained"
                                                    color="info"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={handleSubmitDeviceInformationEdit}
                                                >
                                                    Save
                                                </MDButton>
                                            </MDBox>
                                        </Card>
                                    </Modal>
                                    <Modal
                                        open={openContactDetailsEditModal}
                                        onClose={handleCloseContactDetailsEditModal}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "40%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                p: 2,
                                            }}
                                        >
                                            <ContactDeviceAccess selectedContactDeviceAccess={selectedContactDeviceAccess} entity_id={device?.attributes?.EntityAddressItem?.entity_id} address_item_id={device?.attributes?.EntityAddressItem?.address_item_id} />

                                            <MDBox
                                                ml="auto"
                                                mt={3}
                                                display="flex"
                                                justifyContent="flex-end"
                                            >
                                                <MDButton
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={handleCloseContactDetailsEditModal}
                                                >
                                                    Cancel
                                                </MDButton>
                                                <MDButton
                                                    variant="contained"
                                                    color="info"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={handleSubmitContactDetailsEdit}
                                                >
                                                    Save
                                                </MDButton>
                                            </MDBox>
                                        </Card>
                                    </Modal>
                                    <Modal
                                        open={serviceRequestLogModal}
                                        onClose={handleServiceRequestModalClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",

                                                width: "80%", // Set the desired width here
                                                backgroundColor: "white",
                                                p: 4,
                                            }}
                                        >
                                            <ServiceRequestStatusLogForm
                                                setServiceRequestLogModal={setServiceRequestLogModal}
                                                logServiceRequestId={logServiceRequestId}
                                            />
                                        </Card>
                                    </Modal>

                                    <Modal
                                        open={deviceDisconnectModal}
                                        onClose={handleDeviceDisconnectModalClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "70%", md: "50%" }, // Set the desired width here
                                                backgroundColor: "white",
                                                paddingTop: 1,
                                            }}
                                        >
                                            <DeviceDisconnectForm
                                                deviceName={name?.text}
                                                localIP={paramValue?.local_ip}
                                                // externalId = {device?.external_device_id}
                                                externalId={paramValue?.id}
                                                showToast={showToast}
                                                handleModalClose={handleDeviceDisconnectModalClose}
                                            />
                                        </Card>
                                    </Modal>

                                    <Modal
                                        open={openServiceModal}
                                        onClose={handleServiceModalClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                width: { xs: "90%", sm: "70%", md: "50%", lg: "40%" }, // Set the desired width here
                                                height: {
                                                    xs: "90vh",
                                                    sm: "90vh",
                                                    md: "700px",
                                                    lg: "700px",
                                                },
                                                backgroundColor: "white",
                                                paddingTop: "15px",
                                                paddingLeft: "10px",
                                                paddingRight: "10px",
                                                paddingBottom: "10px",
                                            }}
                                        >
                                            <ServiceRequestsForm
                                                deviceId={id}
                                                device={device?.attributes}
                                                serviceRequestEditFlag={serviceRequestEditFlag}
                                                serviceRequest={serviceRequest}
                                                setServiceModal={setServiceModal}
                                                setServiceRequests={setServiceRequests}
                                                setServiceStatusUpdate={setServiceStatusUpdate}
                                                showToast={showToast}
                                            />
                                        </Card>
                                    </Modal>
                                    <Modal open={openModal} onClose={() => setOpenModal(false)}>
                                        <MDBox tabIndex={-1}>
                                            <GoogleMapComponent
                                                lat={gps.latitude}
                                                lng={gps.longitude}
                                                edit={gps.edit}
                                                onLocationChange={handleLocationChange}
                                            />
                                        </MDBox>
                                    </Modal>
                                    <Modal
                                        open={phoneEnvModal}
                                        onClose={() => setPhoneEnvModal(false)}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Card
                                            sx={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",

                                                width: isTabletOrMobile ? "80%" : "20%", // Set the desired width here
                                                backgroundColor: "white",
                                                p: 4,
                                            }}
                                        >
                                            <MDTypography variant="h4" textAlign="center">
                                                Select Phone environment
                                            </MDTypography>
                                            <table className="table table-borderless">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row" className="text-sm-end text-start">
                                                            <MDTypography fontSize={1}>
                                                                <span style={{ fontWeight: "700" }}>
                                                                    Production Phone:
                                                                </span>
                                                            </MDTypography>
                                                        </th>
                                                        <td style={styles.cell}>
                                                            <Switch
                                                                checked={phoneEnv.is_production}
                                                                onChange={(e) =>
                                                                    handlePhoneSwitch(
                                                                        e.target.checked,
                                                                        "is_production"
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="text-sm-end text-start">
                                                            <MDTypography fontSize={1}>
                                                                <span style={{ fontWeight: "700" }}>
                                                                    Sandbox Phone:
                                                                </span>
                                                            </MDTypography>
                                                        </th>
                                                        <td style={styles.cell}>
                                                            <Switch
                                                                checked={phoneEnv.is_sandbox}
                                                                onChange={(e) =>
                                                                    handlePhoneSwitch(
                                                                        e.target.checked,
                                                                        "is_sandbox"
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="text-sm-end text-start">
                                                            <MDTypography fontSize={1}>
                                                                <span style={{ fontWeight: "700" }}>
                                                                    Development Phone:
                                                                </span>
                                                            </MDTypography>
                                                        </th>
                                                        <td style={styles.cell}>
                                                            <Switch
                                                                checked={phoneEnv.is_development}
                                                                onChange={(e) =>
                                                                    handlePhoneSwitch(
                                                                        e.target.checked,
                                                                        "is_development"
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-evenly",
                                                }}
                                            >
                                                <MDButton
                                                    variant="gradient"
                                                    color="secondary"
                                                    size="small"
                                                    px={2}
                                                    my={2}
                                                    sx={{
                                                        marginLeft: "10px",
                                                    }}
                                                    onClick={() => setPhoneEnvModal(false)}
                                                >
                                                    Cancel
                                                </MDButton>
                                                <MDButton
                                                    variant="gradient"
                                                    color="secondary"
                                                    size="small"
                                                    px={2}
                                                    my={2}
                                                    sx={{
                                                        marginLeft: "10px",
                                                    }}
                                                    onClick={clickSetPhoneOption}
                                                >
                                                    Save
                                                </MDButton>
                                            </div>
                                        </Card>
                                    </Modal>
                                    <Grid item xs={12} sm={8} lg={4}>
                                        <Tabs
                                            value={selectedTab}
                                            orientation={tabsOrientation}
                                            onChange={handleTabChange}
                                            aria-label="Tabs"
                                            sx={{ display: "flex" }}
                                        >
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-file-alt"
                                                            style={{ marginRight: "2px" }}
                                                        ></i>
                                                        Logs
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-exclamation-triangle"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Alerts
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fa-solid fa-clock"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Routes
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fa-solid fa-clock"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Events
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-code-branch"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Rules
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1.5", p: "2" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "0px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-tools"
                                                            style={{ marginRight: "0px" }}
                                                        ></i>
                                                        <Typography
                                                            sx={{ fontSize: { xs: "0.825rem", sm: "1rem" } }}
                                                        >
                                                            Service Request
                                                        </Typography>
                                                    </Box>
                                                }
                                            />
                                        </Tabs>
                                    </Grid>

                                    {selectedTab === 0 && Object.keys(reportType).length > 0 && (
                                        <LogsTable
                                            columns={dataTableData.columns}
                                            id={id}
                                            getRows={getRows}
                                            canSearch={true}
                                            canDelete={true}
                                            canExport={true}
                                            isSelection={true}
                                            exportFunc={clickExportLogsHandler}
                                        />
                                    )}
                                    {selectedTab === 1 && (
                                        <>
                                            <Modal
                                                open={openViewModal}
                                                onClose={handleViewClose}
                                                aria-labelledby="modal-title"
                                                aria-describedby="modal-description"
                                            >
                                                <Card
                                                    sx={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                        width: "80%", // Set the desired width here
                                                        backgroundColor: "white",
                                                        boxShadow: 24,
                                                        p: 4,
                                                        maxHeight: "70vh", // Set max height to enable scrolling
                                                        overflowY: "auto",
                                                        overflowX: "hidden",
                                                    }}
                                                >
                                                    <CardContent>
                                                        <DynamicDataTable Alert={alert} />
                                                    </CardContent>
                                                </Card>
                                            </Modal>

                                            <MDBox pt={6} pb={3}>
                                                <MDBox mb={3}>
                                                    <CollapsibleTable
                                                        width="100%"
                                                        data={alertTableData}
                                                        columns={alertColumns}
                                                        clickViewHandler={clickViewHandler}
                                                        clickDeleteHandler={clickDeleteHandler}
                                                        page={page}
                                                        setPage={setPage}
                                                        rowsPerPage={rowsPerPage}
                                                        setRowsPerPage={setRowsPerPage}
                                                        count={countRef.current}
                                                    />
                                                </MDBox>
                                            </MDBox>
                                        </>
                                    )}
                                    {selectedTab === 2 && (
                                        <>
                                            <RouteModal selectedRouteGroup={selectedRouteGroup} setSelectedRouteGroup={setSelectedRouteGroup} />
                                            <RouteCollapsibleTabTable
                                                width="100%"
                                                data={getRouteTable(routeAllData)}
                                                columns={routeColumns}
                                                subColumns={routeSubColumns}
                                                clickInfoHandler={clickInfoHandler}
                                                clickViewHandler={clickRouteViewHandler}
                                                clickSubRouteViewHandler={clickSubRouteViewHandler}
                                                clickExportHandler={clickExportHandler}
                                                clickDeleteHandler={clickRouteDeleteHandler}
                                                openLogs={openLogs}
                                                page={page}
                                                setPage={setPage}
                                                rowsPerPage={rowsPerPage}
                                                setRowsPerPage={setRowsPerPage}
                                                count={countRef.current}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 3 && (
                                        <>
                                            <EventsTable
                                                columns={eventdataTableData.columns}
                                                id={id}
                                                getRows={getEventRows}
                                                canSearch={true}
                                                canDelete={true}
                                                isSelection={true}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 4 && (
                                        <>
                                            <MDBox
                                                p={3}
                                                lineHeight={1}
                                                display="flex"
                                                justifyContent="right"
                                            >
                                                <MDButton
                                                    color="dark"
                                                    size="small"
                                                    onClick={() => {
                                                        setAlertRule();
                                                        setOpenViewModal(true);
                                                    }}
                                                >
                                                    Add Rule
                                                </MDButton>
                                            </MDBox>
                                            <DataTable
                                                table={alertRuledataTableData}
                                                canSearch={true}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 5 && (
                                        <MDBox sx={{ marginTop: "20px" }}>
                                            <Can I="view" this={"phone"}>
                                                <MDBox>
                                                    <MDButton
                                                        variant={"gradient"}
                                                        color="primary"
                                                        size="small"
                                                        px={2}
                                                        my={2}
                                                        mx={2}
                                                        onClick={() => setPhoneEnvModal(true)}
                                                    >
                                                        Open Phone
                                                    </MDButton>
                                                </MDBox>
                                            </Can>
                                            {checkRowSelectedRowsFlag && (
                                                <MDBox>
                                                    <MDButton
                                                        variant="gradient"
                                                        color="primary"
                                                        size="small"
                                                        px={2}
                                                        my={2}
                                                        mx={2}
                                                        onClick={clickStatusEdit}
                                                    >
                                                        Edit
                                                    </MDButton>

                                                    <MDButton
                                                        variant="gradient"
                                                        color="secondary"
                                                        size="small"
                                                        px={2}
                                                        my={2}
                                                        sx={{
                                                            marginLeft: "10px",
                                                        }}
                                                        onClick={clickCancelSelection}
                                                    >
                                                        Cancel Selection
                                                    </MDButton>
                                                </MDBox>
                                            )}

                                            <ServiceRequestDataTable
                                                table={serviceRequestdataTableData}
                                                canSearch={true}
                                                onRowClick={clickServiceReqeustRowHandler}
                                                handleSelectedRows={handleSelectedRows}
                                                selectedRows={selectedRows}
                                                setDataTableUpdate={setDataTableUpdate}
                                            />
                                        </MDBox>
                                    )}
                                    <JsonTree open={selectedLogInfo} onClose={() => setSelectedLogInfo(null)} data={selectedLogInfo} darkTheme={true} />
                                    <MDBox
                                        ml="auto"
                                        mt={4}
                                        mb={2}
                                        display="flex"
                                        justifyContent="flex-end"
                                    >
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() =>
                                                    navigate("/devices", {
                                                        state: {
                                                            value: false,
                                                            text: "",
                                                        },
                                                    })
                                                }
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <JsonTree open={openJsonTree} onClose={() => setJsonTree(false)} data={rawDataValue} />
            <Dialog
                open={deviceLogModel}
                onClose={() => setDeviceLogModel(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Select Date Range"}
                </DialogTitle>
                <DialogContent>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <MDDatePicker
                            label="From"
                            value={dateRange[0]}
                            onChange={(newValue) => setDateRange((prev) => [newValue, prev[1]])}
                            options={{
                                dateFormat: "Y-m-d",
                                maxDate: new Date(),
                            }}
                            input={{ placeholder: "From" }}
                        />
                        <MDDatePicker
                            label="To"
                            value={dateRange[1]}
                            onChange={(newValue) => setDateRange((prev) => [prev[0], newValue])}
                            options={{
                                dateFormat: "Y-m-d",
                                maxDate: new Date(),
                            }}
                            input={{ placeholder: "To" }}
                        />
                    </Stack>
                </DialogContent>
                <DialogContent>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <MDInput
                            label="Page"
                            type="number"
                            min="1"
                            value={pagin[0]}
                            onChange={(e) => setpagin((prev) => [e.target.value, prev[1]])}
                        />
                        <MDInput
                            label="No. of Page"
                            type="number"
                            min="50"
                            value={pagin[1]}
                            onChange={(e) => setpagin((prev) => [prev[0], e.target.value])}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        disabled={!dateRange[0] || !dateRange[1] || loader}
                        onClick={handleExport}
                    >
                        <i className="fas fa-file-export"></i>&nbsp; Export
                    </Button>
                </DialogActions>
            </Dialog>
            <Footer />
        </DashboardLayout>
    );
};

export default AssetTracker;